/* eslint-disable @typescript-eslint/member-ordering */
import { Component, OnInit, Input, ViewContainerRef, Output, EventEmitter, ViewChild, AfterViewInit, HostListener, ElementRef, QueryList, ViewChildren, OnChanges, SimpleChanges, ChangeDetectorRef, OnDestroy, Renderer2 } from "@angular/core";
import { RestService } from "../../shared/rest.service";
import { Procesed } from "../../shared/enum-procesed";
import { ItineraryService } from "../../shared/itinerary.service";
import { ModalDirective, BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { ModalsSearchComponent } from "../../shared/modals-search/modals-search.component";
import { UserService } from "../../pages/com.usblick.common/auth/user.service";
import { ResultsSearchService } from "../../home/results-search.service";
import { ModalsComponent } from "../../shared/modals/modals.component";
import { MatDialog } from "@angular/material/dialog";
import { MaterialModalAlertComponent } from "../../shared/material-modal-alert/material-modal-alert.component";
import { Options } from "@angular-slider/ngx-slider";
import { MatCheckbox } from "@angular/material/checkbox";
import { TitleFilterPipe } from '../../shared/titleFilter.pipe';
import { Router } from "@angular/router";
import { createAcrissFilter, createAmenitiesFilter, createAmenitiesFilterTour, createContractRentACar, createCoverageInsuranceFilter, createDoorsFilter, createLanguageFilterTour, createLuggageFilter, createMealsFilter, createModalityInsuranceFilter, createQtyMaxPassenger, createSessionsFilter, createTransmisionFilter, createUpgradeInsuranceFilter, createVehicleTypes, FiltersHotels, FiltersRentacar, SliderShow, typeTranslate, VehicleTypes, createFlightAirlinesFilter, createFlightStopsFilter, createFlightCabinClassFilter, createFlightDepartureAirportsFilter, createFlightTimeFilter, createFlightAttributesFilter, getFlightTotalDurationHours, getFlightTimeBucketKey, flightHasAttribute, getFlightPrice } from "./filters-model";
import { PriceFilterPipe } from "app/shared/slider.pipe";
import { HttpErrorResponse } from "@angular/common/http";
import { BehaviorSubject, Subject, Subscription } from "rxjs";
import { Filter, filterDynamic } from "./filter-categories";
import CssFilterConverter from "css-filter-converter";
import { takeUntil } from "rxjs/operators";
import { HotelRoomState, HotelService } from "app/shared/modals/modal-hotel/hotel.service";
import { NotFoundModalComponent } from "app/shared/modals/not-found-modal/not-found-modal.component";
import { RestorePayloadService } from "../services/restore-payload.service";

interface FilterChip {
  name: string;
  type: string;  // 'order', 'priceRange', 'text', 'stars', 'board', 'cancellation', 'amenities', 'vehicle', 'passengers', 'doors', 'rentadora', 'language', 'schedule'
  value?: any;   // Valor específico para restaurar
}



@Component({
  selector: "usb-category-result",
  templateUrl: "./category-result.component.html",
  styleUrls: ["./category-result.component.scss"],
  providers: [
    TitleFilterPipe,
    PriceFilterPipe
  ]
})
export class CategoryResultComponent implements OnInit, AfterViewInit, OnChanges {
  items = Array.from({ length: 100000 }).map((_, i) => `Item #${i}`);

  @Input() payload: any;
  @Input() _form: any;
  @Input() results: any;
  @Input() _paxAdults: any;
  @Input() _paxChildren: any;
  @Input() index: any;
  @Input() _pax: any;
  @Input() _payloadForm: any;
  @Input() show: any;
  @Input() _multiModal: any;
  @Input() modalRoomRef: any;
  @Input()
  origin!: string;
  @Input()
  tabSelected!: string;
  @Input()
  categoryName!: string;
  @Input()
  text!: string;
  @Input() resultPaged: any;
  @Input() _applyFilter: any;
  @Input() deleteProduct: string = '';
  @Input() getClientsSettingAppBooking: any;
  @Input() _actualItinerary: any;
  @Input() itineraryCurrency: string = '';
  @Input() formTransports: any;
  @Input()
  categoryId!: number;
  @Input() openModalResearch: boolean = false;
  @Input()
  reloadSearching!: boolean;
  @Input()
  currencies!: any[];
  @Input() currencyAgency: any;
  @Input()
  qtyProductValid!: number;
  @Input()
  eventModifiedTransportPriceSelectedReturn!: boolean;
  @Input() paymentAgencyActive: any;

  // Resultados de vuelos: "full" = como llega hoy (vuelo completo,
  // combinado); "byLeg" = elegir cada tramo por separado (ida/vuelta/tramo
  // N), un producto de itinerario por tramo.
  flightViewMode: 'full' | 'byLeg' = 'full';

  @Output() arrayOut = new EventEmitter<any>();
  @Output() isLoading = new EventEmitter<boolean>();
  @Output() payload_ = new EventEmitter<any>();
  @Output() results_ = new EventEmitter<any>();
  @Output() _origin = new EventEmitter<any>();
  @Output() _filtersRentacar = new EventEmitter<any>();
  @Output() emitReSearch = new EventEmitter<any>();
  @Output() emitViewMap = new EventEmitter<any>();
  @Output() openModalFly = new EventEmitter<any>();
  @Output() qtyProductValidDecrementEmmit = new EventEmitter<any>();
  @Output() reloadEditPencilEmitter = new EventEmitter<any>();
  @Output() resultsRentacarAcriss = new EventEmitter<any>();
  @ViewChildren('icon', { read: ElementRef })
  icons!: QueryList<ElementRef>;
  @ViewChildren('buttonsStar')
  buttons!: QueryList<ElementRef>;
  @ViewChildren('icons_two', { read: ElementRef })
  icons_two!: QueryList<ElementRef>;
  @ViewChild('ngxSlider')
  slider!: ElementRef;
  @ViewChild(ModalDirective)
  modalCompare!: ModalDirective;
  @ViewChild("ModalRooms") public formModal: any;
  @ViewChild(ModalsSearchComponent)
  modalSearch!: ModalsSearchComponent;
  @ViewChild("map") gmapElement: any;
  @ViewChild('filterContainer')
  filterContainer!: ElementRef;
  @ViewChildren('containerResults') containerResults!: QueryList<ElementRef>;
  @ViewChildren('filterCheckbox') checkboxes!: QueryList<ElementRef<HTMLInputElement>>;
  @ViewChildren('insuranceResult')
  insuranceResults!: QueryList<ElementRef>;
  // filtros
  @ViewChild("popularBreakfast")
  public popularBreakfast!: MatCheckbox;
  @ViewChild("popularBreakfastNo")
  public popularBreakfastNo!: MatCheckbox;
  @ViewChild('showOrderContainer') showOrderContainer!: ElementRef;

  @HostListener('document:click', ['$event'])
  handleClick(event: Event) {
    if (this.filterContainer && !this.filterContainer.nativeElement.contains(event.target)) {
      if(this.payload?.categoriesId?.[0] !== 10) {
        this.showFilters = false;
      }
    }
  }

  coordinatesSidebar = {lat: 0, lng: 0};
  config = {
    backdrop: 'static',  // Evita el cierre al hacer clic fuera del modal
    keyboard: false,     // Desactiva el cierre con la tecla Escape
    class: 'modal-dialog-centered'
  };

  page: any;
  ModalRooms: any;
  modalRef!: BsModalRef;
  category!: string;
  loaded!: boolean;
  _current = 1;
  _total!: number;
  contentCollapsed = true;
  _currentGlobal = 1;
  _items!: number;
  editable = false;
  itemToCompare: any = [];
  disbaledCompare: boolean = false;
  ori: any;
  emitLoad: boolean = false;
  orderFilter = 0;
  nightsTotalDiff:number = 0;
  cityNameForm:any;
  currentInfo:any;
  markerArray: google.maps.Marker[] = [];
  selectedStars: number = 0; // Número de estrellas seleccionadas
  booleanHideIcons:boolean = false;
  selectedAmenities: string[] = [];
  filterInitialized: boolean = false;
  resultTotal!: number;
  priceResetLow:number = 0;
  priceResetHigh:number = 0;
  private hasExecutedElse: boolean = false;
  orderPriceby =   "priceLow";
  orderOptions = {
    priceLow: "Menor Precio",
    priceHigh: "Mayor Precio",
    masRelevantes: "Mas Relevantes",
  };
  showOrder = false;
  showFilters = false;

  isChecked = true;
  activeStars: number = -1;
  currentPayload: any;

  countFilterApply = 0;
  selectedFilters: any = [];
  resultReload: boolean = false;
  noLoadingForModal = false;

  textBarCharge: string = 'Cargando más resultados...';
  filterColorIcon: any;

  paxesSelected: any[] = [];

  visualMap: boolean = false;

  // MISCELANEOS
  resultFilterCount = [];
  totalProduct = 0;
  filterLowPrice: any = 0;
  filterHighPrice: any = 0;
  initialLowPrice: any;
  initialHigthPrice: any;
  optionsSliderPrice: Options = SliderShow;
  bsModalRef?: BsModalRef;
  headerStyle: any;

  coordinatesArr: any[] = [];
private reloadTimeout: any;


  // HOTELES
  public filters: any = FiltersHotels;
  mealsFilter: any[] = [];
  amenitiesFilter: any[] = [];
  selectedAmenityKeywords: string[] = [];
  selectedRateTypes: string[] = [];
  selectedBoardKeys: string[] = [];

  // TOUR
  languageFilter: any[] = [];
  languageKeys: string[] = [];
  sessionsFilter: any[] = [];
  sessionsKeys: string[] = [];

  // TRASLADOS
  selectedVehicleKeys: string[] = [];
  vehicleTypeFilter: any[] = [];
  selectedVehicleServiceKeys: string [] = [];
  vehicleServiceFilter = typeTranslate;

  // RENT-A-CAR
  public  filtersRentacar: any = FiltersRentacar;
  luggageFilter:any[] = [];
  luggageSelected:any[] = [];
  acrissFilter:any[] = [];
  acrissSelected:any[] = [];
  transmissionFilter:any[] = [];
  transmissionSelected:any[] = [];
  quantityDoorsFilter:any[] = [];
  quantityMaxPassengerFilter:any[] = [];
  doorsSelected:any[] = [];
  supplierContractRentACarFilter: any[] = [];
  maxPaxSelected: any[] = [];
  supplierRentACarSelected: any[] = [];

  // ASISTENCIA
  modalityFilter: any[] = [];
  coverageFilter: any[] = [];
  upgradesFilter: any[] = [];

  // VUELOS
  airlinesFilterFlights: { key: string; label: string; matches: string[]; count: number }[] = [];
  selectedAirlinesFlights: string[] = [];
  showAllAirlinesFlights = false;
  stopsFilterFlights: { key: string; label: string; count: number }[] = [];
  selectedStopsFlights: string[] = [];
  cabinClassFilterFlights: { key: string; label: string; matches: string[]; count: number }[] = [];
  selectedCabinClassesFlights: string[] = [];
  departureAirportsFilterFlights: { key: string; label: string; count: number }[] = [];
  selectedDepartureAirportsFlights: string[] = [];
  departureTimeFilterFlights: { key: string; label: string; range: string; icon: string; count: number }[] = [];
  selectedDepartureTimeFlights: string[] = [];
  arrivalTimeFilterFlights: { key: string; label: string; range: string; icon: string; count: number }[] = [];
  selectedArrivalTimeFlights: string[] = [];
  flightAttributesFilter: { key: string; label: string; count: number }[] = [];
  selectedFlightAttributes: string[] = [];
  flightDurationRangeHours: { min: number; max: number } = { min: 0, max: 48 };
  selectedMaxDurationHoursFlights: number = null;
  optionsSliderDuration: Options = { floor: 0, ceil: 48, hidePointerLabels: true, hideLimitLabels: true };


  viewMapsResult = false;
  viewCardResult = false;

  allpost;
  notEmptyPost = true;
  notscrolly = true;
  resultsFilter: any;
  resultsAux: any;
  init = false;
  nuevoObjeto = [];
  nuevoObjetoAux = [];
  private intervalId: any; // Variable para almacenar el ID del intervalo
  first_charge: boolean = true;
  resultsReset: any;
  reloadAgain: boolean = true;
  private reloadAgainSubject = new BehaviorSubject<boolean>(this.reloadAgain);
  currencyItinerary: any = null;
  arrivalDate!: string;
  departureDate!: string;
  finishReload: boolean = false;
  totalResponse!: number;
  indexResolveResult = 0;
  searchId: any;
  resultPagedAux: any[] = [];
  filterActivated: boolean = false;
  filter: Filter[] = [];
  selectedNoCloneVehicle: boolean = false;
  stylePathPrice: any;

  public pausedByMouseEnter = false; // Flag para pausar/reanudar recarga
  public isSearchRunning = false; // Flag para saber si una búsqueda está en progreso

  confirmSubscription!: Subscription;
  oneWaySubscription!: Subscription;

pickupLocation: any;
dropoffLocation: any;

  private destroy$ = new Subject<void>();

private documentClickListener?: () => void;
private documentKeydownListener?: () => void;

// Definir configuración de filtros
private readonly filterConfig: Record<number, Array<{ name: string; isActive: () => boolean }>> = {
  1: [ // Hoteles
    { name: 'Nombre', isActive: () => !!this.text?.trim() },
    { name: 'Categoría', isActive: () => this.selectedStars > 0 },
    { name: 'Régimen', isActive: () => this.selectedBoardKeys.length > 0 },
    { name: 'Cancelación', isActive: () => this.selectedRateTypes.length > 0 },
    { name: 'Amenities', isActive: () => this.selectedAmenityKeywords.length > 0 }
  ],
  2: [ // Rent a Car
    { name: 'Tipo de vehículo', isActive: () => !!this.acrissSelected?.length },
    { name: 'Pasajeros', isActive: () => !!this.maxPaxSelected?.length },
    { name: 'Puertas', isActive: () => !!this.luggageSelected?.length },
    { name: 'Rentadora', isActive: () => !!this.supplierRentACarSelected?.length }
  ],
  5: [ // Vuelos
    { name: 'Escalas', isActive: () => this.selectedStopsFlights.length > 0 },
    { name: 'Aerolíneas', isActive: () => this.selectedAirlinesFlights.length > 0 },
    { name: 'Clase preferida', isActive: () => this.selectedCabinClassesFlights.length > 0 },
    { name: 'Aeropuerto de salida', isActive: () => this.selectedDepartureAirportsFlights.length > 0 },
    { name: 'Horario de salida', isActive: () => this.selectedDepartureTimeFlights.length > 0 },
    { name: 'Horario de llegada', isActive: () => this.selectedArrivalTimeFlights.length > 0 },
    { name: 'Duración del viaje', isActive: () => this.selectedMaxDurationHoursFlights !== null && this.selectedMaxDurationHoursFlights < this.flightDurationRangeHours.max },
    { name: 'Viaje y equipaje', isActive: () => this.selectedFlightAttributes.length > 0 }
  ],
  6: [ // Tours
    { name: 'Nombre', isActive: () => !!this.text?.trim() },
    { name: 'Idioma', isActive: () => this.filter.some(c => c.path === 'language') },
    { name: 'Horario', isActive: () => this.filter.some(c => c.path === 'sessions') }
  ],
  8: [ // Transportes
    { name: 'Tipo de vehículo', isActive: () => this.filter.some(c => c.path === 'vehicle.type') },
    { name: 'Tipo de servicio', isActive: () => this.filter.some(c => c.path === 'transferType') }
  ],
  9: [ // Generic
    { name: 'Nombre', isActive: () => !!this.text?.trim() }
  ],
  10: [ // Generic
    { name: 'Nombre', isActive: () => !!this.text?.trim() }
  ]
};

    constructor(
      private modalService: BsModalService,
      public vcr: ViewContainerRef,
      private _restService: RestService,
      public serviceItinerary: ItineraryService,
      public userService: UserService,
      public resultsSearch: ResultsSearchService,
      private dialog: MatDialog,
      private titleFilter: TitleFilterPipe,
      private sliderFilter: PriceFilterPipe,
      private itineraryService: ItineraryService,
      private route: Router,
      private cdr: ChangeDetectorRef,
      private renderer: Renderer2,
      private hotelService: HotelService,
      private retorePayloadService: RestorePayloadService
    ) {
      this.init = false;

    }
  ngOnDestroy(): void {
    // this.confirmSubscription.unsubscribe();
    if(this.categoryId === 8) {
      this.oneWaySubscription.unsubscribe();
    }

      if (this.documentClickListener) {
    this.documentClickListener();
  }
  if (this.documentKeydownListener) {
    this.documentKeydownListener();
  }

       this.destroy$.next();
      this.destroy$.complete();
  }


  ngOnInit() {

    this.payload.providersId = this.userService._providerId;
    this.paxesSelected = Array.from({ length:  this.results.length }, () => []);

  this.optionsSliderPrice = {
    hidePointerLabels: true,  // Oculta los números en los punteros
    hideLimitLabels: true,    // Oculta los números en los extremos
    minRange: 20,
    noSwitching: true
  };

    this.headerStyle = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_body);
    this.stylePathPrice = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_body);
    this.applyImageFilter();
    this.arrivalDate = this.payload.arrivalDate;
    this.departureDate = this.payload.departureDate;
    if(this.origin === 'TOURS' ||
      this.origin === 'RENT-A-CAR' ||
      this.origin === 'INSURANCE' ||
      this.origin === 'TRANSPORTS'){

      this.resultPaged = this.results;
    }

    if(this.origin === 'FLIGHTS') {

      if(this.results.flights) {
        this.resultPaged = this.results;
      } else {
        this.resultPaged = this.results;
      }
    }

    this.cityNameForm = JSON.parse(localStorage.getItem('form')); // Carga el formulario del LocalStorage
    this.categoryId = this.payload?.categoriesId?.[0]; // id de categoría

    this.handleCategoryValidation(); // Validación según la categoría seleccionada
    if(this.categoryId === 1) {



      this.hotelService.initializeSelection(this._form.room);

      this.hotelService.state$.subscribe((state: HotelRoomState | null) => {
        if (state) {
          this.qtyProductValid = state.remainingConfigs.length;

        }
      });
    }

    if(this.categoryId === 6) {
      this.initializeRentacarFilters(); // Inicializa filtros de Rent-a-Car
    }
    if(this.categoryId === 8) {
      this.subscriptionOneWay();
      if(!this.payload.transfers.oneWay) {
        this.itineraryService.setBackupResults(this.results);
        this.subscribeToNoCloneVehicle();

      if(!this.payload.transfers.oneWay && this.eventModifiedTransportPriceSelectedReturn) {
        this.modifyAllVehicles();
      }
      }
    }
    if(this.categoryId === 10) {
       // Si no existe, inicializar paxesSelected como array de arrays vacíos
  if (!this.paxesSelected || this.paxesSelected.length === 0) {
    this.paxesSelected = new Array(this.resultPaged.length).fill([]);
      }

      // Asignar ID único a cada pasajero si no lo tiene
      this._form.paxes.forEach((pax: any, index: number) => {
        if (!pax.tempId) {
          // Usar combinación de propiedades para ID único
          pax.tempId = this.generatePaxId(pax, index);
        }
      });
    }


    this.showOrderObservable();

    if(this.payload && Array.isArray(this.payload)) {
      this.payload = this.payload[0];
    }

    this.resultsSearch.reloadSearchHotel$.subscribe(() => {
      this.researchPaxList(this.payload, false, false);
    });

  }



// En el componente padre (donde tienes _form.paxes)

/**
 * Genera un ID único para un pasajero
 */
private generatePaxId(pax: any, index: number): string {
  // Si tiene propiedades únicas, usarlas para el ID
  if (pax.document_number) {
    return `pax-${pax.document_number}-${pax.first_name || ''}-${pax.last_name || ''}`;
  }
  // Si no, usar índice
  return `pax-index-${index}`;
}

/**
 * Método para obtener paxes disponibles específicos para cada hijo.
 *
 * Devuelve TODOS los paxes del formulario, INCLUYENDO los ya seleccionados
 * en ESTA card (`index`). La razón: el dropdown de la card actual debe poder
 * mostrar los paxes ya seleccionados para permitir desmarcarlos. Excluirlos
 * rompe la UX (la opción no existe en el DOM y Material no puede quitarla).
 *
 * Los paxes seleccionados en OTRAS cards sí se filtran: una persona no puede
 * comprar más de un seguro. Esa restricción se valida también en
 * `onPaxesChange` con `findConflicts`.
 */
getPaxesDisponiblesParaHijo(index: number) {
  // 1. IDs de paxes seleccionados en OTRAS cards (excluyendo la actual)
  const allSelectedIds = this.getAllSelectedPaxIdsExcluding(index);

  // 2. Devolver todos los paxes excepto los que están en otras cards
  return this._form.paxes.filter(pax =>
    !allSelectedIds.has(pax.tempId)
  );
}

/**
 * Obtiene los IDs de paxes seleccionados en todas las cards EXCEPTO la indicada.
 */
private getAllSelectedPaxIdsExcluding(excludeIndex: number): Set<string> {
  const ids = new Set<string>();

  this.paxesSelected.forEach((selectionArray, i) => {
    if (i === excludeIndex) return;
    if (Array.isArray(selectionArray)) {
      selectionArray.forEach(pax => {
        if (pax && pax.tempId) {
          ids.add(pax.tempId);
        }
      });
    }
  });

  return ids;
}

/**
 * Obtiene un Set con los IDs de todos los paxes seleccionados
 */
private getAllSelectedPaxIds(): Set<string> {
  const allSelectedIds = new Set<string>();

  this.paxesSelected.forEach(selectionArray => {
    if (Array.isArray(selectionArray)) {
      selectionArray.forEach(pax => {
        if (pax && pax.tempId) {
          allSelectedIds.add(pax.tempId);
        }
      });
    }
  });

  return allSelectedIds;
}

/**
 * Maneja cambio en selección de pasajeros de un hijo
 */
onPaxesChange(index: number, nuevosPaxes: any[]) {

  // 1. Asegurar que el array tenga la longitud correcta
  this.ensurePaxesSelectedLength();

  // 2. Validar que los nuevos paxes no estén ya seleccionados en otros hijos
  const conflictos = this.findConflicts(index, nuevosPaxes);

  if (conflictos.length > 0) {
    return;
  }

  // 3. Actualizar selección para este hijo
  this.paxesSelected[index] = [...nuevosPaxes];
}

/**
 * Asegura que paxesSelected tenga la longitud correcta
 */
private ensurePaxesSelectedLength(): void {
  const expectedLength = this.resultPaged.length;

  if (this.paxesSelected.length < expectedLength) {
    // Agregar arrays vacíos para los nuevos elementos
    for (let i = this.paxesSelected.length; i < expectedLength; i++) {
      this.paxesSelected.push([]);
    }
  } else if (this.paxesSelected.length > expectedLength) {
    // Recortar si hay más de lo necesario
    this.paxesSelected = this.paxesSelected.slice(0, expectedLength);
  }
}

/**
 * Encuentra conflictos (paxes ya seleccionados en otros hijos)
 */
private findConflicts(currentIndex: number, nuevosPaxes: any[]): any[] {
  const conflictos = [];
  const nuevosIds = nuevosPaxes.map(pax => pax.tempId);

  this.paxesSelected.forEach((selectionArray, index) => {
    if (index !== currentIndex && Array.isArray(selectionArray)) {
      selectionArray.forEach(pax => {
        if (pax && pax.tempId && nuevosIds.includes(pax.tempId)) {
          conflictos.push({
            pax: pax,
            selectedInIndex: index,
            conflictedWithIndex: currentIndex
          });
        }
      });
    }
  });

  return conflictos;
}
  // En tu componente
groupResultsByFirstImage(results: any[]): any[] {
  const imageGroups = new Map();

  results.forEach(result => {
    // Obtener la primera imagen del array images
    const firstImage = result.images && result.images.length > 0
      ? result.images[0]
      : 'no-image';

    if (!imageGroups.has(firstImage)) {
      // Crear nuevo grupo con la primera imagen como clave
      imageGroups.set(firstImage, {
        ...result,
        plans: [result.plan] // Inicializar array de planes con el primer plan
      });
    } else {
      // Agregar el plan al array de planes del grupo existente
      const group = imageGroups.get(firstImage);
      group.plans.push(result.plan);
    }
  });

  return Array.from(imageGroups.values());
}

onPlanSelectCompare(value: any): void {
  const position = this.findPlanPosition(value);

  if (position) {
    this.movePlanToFirstPosition(position);
    this.scrollToPosition(position.groupIndex);
  }
}

private findPlanPosition(value: any): { groupIndex: number, planIndex: number, group: any } | null {
  for (let groupIndex = 0; groupIndex < this.resultPaged.length; groupIndex++) {
    const group = this.resultPaged[groupIndex];

    if (group.insurances && Array.isArray(group.insurances)) {
      const planIndex = group.insurances.findIndex((insurance: any) =>
        insurance.plan.planId === value.plan.planId &&
        insurance.plan.planCode === value.plan.planCode
      );

      if (planIndex !== -1) {
        return { groupIndex, planIndex, group };
      }
    }
  }

  console.warn('Plan no encontrado:', value.plan);
  return null;
}

private movePlanToFirstPosition(position: { groupIndex: number, planIndex: number, group: any }): void {
  const { group, planIndex, groupIndex } = position;

  if (planIndex > 0) {
    // Intercambiar posiciones: plan encontrado va al inicio
    const temp = group.insurances[0];
    group.insurances[0] = group.insurances[planIndex];
    group.insurances[planIndex] = temp;

  } else {
  }
}



private scrollToPosition(groupIndex: number): void {
  this.cdr.detectChanges();

  setTimeout(() => {
    const elements = this.insuranceResults.toArray();

    if (!elements[groupIndex]) return;

    const element = elements[groupIndex].nativeElement;

    if (groupIndex === 0) {
      // Ir al inicio de TODO (top absoluto)
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0; // Para Safari

      const thirtyVhInPixels = window.innerHeight * 0.3;

      // Pequeño delay y luego bajar 150px suavemente
      setTimeout(() => {
        window.scrollTo({
          top: thirtyVhInPixels,
          behavior: 'smooth'
        });

        this.highlightElement(element);
      }, 100);
    } else {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
      this.highlightElement(element);
    }
  }, 50);
}

  highlightElement(element: HTMLElement): void {
    element.classList.add('highlight-result');
    setTimeout(() => {
      element.classList.remove('highlight-result');
    }, 2000);
  }

  ngOnChanges(changes: SimpleChanges): void {

    if(changes['payload'] && changes['payload']['previousValue'] !== changes['payload']['currentValue']) {

     this.payload = changes['payload']['currentValue'];
    }

    if(changes['formTransports'] && changes['formTransports']['previousValue'] !== changes['formTransports']['currentValue']) {

     this.formTransports = changes['formTransports']['currentValue'];
     this._form = changes['_form']['currentValue'];
    }


    this.currencyAgency = this.userService.currency;
  }



    private subscribeToNoCloneVehicle(): void {
        this.itineraryService.noCloneVehicleDoubleWay$.pipe(
          takeUntil(this.destroy$)
        ).subscribe(() => {
          this.modifyAllVehicles();
        });
    }

      private modifyAllVehicles(): void {
      if (!this.resultPaged) return;

      this.resultPaged.forEach((item: any) => {
        if (item.vehicles && Array.isArray(item.vehicles)) {
          item.vehicles.forEach((vehicle: any) => {
            this.selectedNoCloneVehicle = true;
            this.applyVehicleModifications(vehicle);
          });
        }
      });
    }

    private applyVehicleModifications(vehicle: any): void {
      // Aplicar las modificaciones necesarias
      vehicle.profility = vehicle?.profilityEntry;
      vehicle.netPriceProf = vehicle?.profilityEntry?.netPriceBooking;
      vehicle.netPriceFreeTax = vehicle?.profilityEntry?.netPrice;
      vehicle.netPriceUnitary = vehicle?.profilityEntry?.netPrice;
      vehicle.totalPriceFreeTax = vehicle?.profilityEntry?.netPriceBooking;
      vehicle.totalPriceProf = vehicle?.profilityEntry?.netPriceBooking;
    }


  private showOrderObservable(): void {
    setTimeout(() => {
    this.documentClickListener = this.renderer.listen(
      'document',
      'click',
      (event: MouseEvent) => {
        if (this.showOrder &&
            this.showOrderContainer &&
            !this.showOrderContainer.nativeElement.contains(event.target)) {
          this.showOrder = false;
        }
      }
    );
  });
  }

  private subscriptionOneWay(): void {
    this.oneWaySubscription = this.itineraryService.noCloneOneWay$.subscribe((clone: boolean) => {
      if(!clone) {
        this.results.forEach((result: any) => {
         result.vehicles = result.vehicles.map((vehicle: any) => {
            if (vehicle?.profilityEntry) {
              return {
                ...vehicle,
                profility: vehicle?.profilityEntry,
                netPriceProf: vehicle?.profilityEntry?.netPriceBooking,
                netPriceFreeTax: vehicle?.profilityEntry?.netPrice,
                netPriceUnitary: vehicle?.profilityEntry?.netPrice,
                totalPriceFreeTax: vehicle?.profilityEntry?.netPriceBooking,
                totalPriceProf: vehicle?.profilityEntry?.netPriceBooking,
              };
            }
            return vehicle;
          });
        })
        this.resultsAux = this.results;
        this.cdr.detectChanges();
      }
    });
  }

// Variables de control
// Variables de control
private searchPromise: Promise<any> | null = null;
private searchResolve: ((value: any) => void) | null = null;
private searchReject: ((reason?: any) => void) | null = null;
private pendingSearch = false;
private lastPayload: any = null;
private lastResponse: any = null;
private nextCheckScheduled = false;
private lastResultsCount: number | null = null; //  guarda la cantidad anterior
private lastCheckTime: number = 0;
private readonly MIN_CHECK_INTERVAL = 2000; // 2 segundos mínimo entre verificaciones
private readonly MAX_RELOAD_ITERATIONS = 2;
private reloadIterations: number = 0;
private lastPollFailed: boolean = false;

// Sin esto, cada ciclo de reload (subscribeReloadSearch) reasigna resultPaged/results con
// objetos nuevos, y Angular destruye y recrea TODAS las cards en cada *ngFor aunque sea el
// mismo hotel — si el click para abrir el modal de producto cae justo en ese instante, el nodo
// sobre el que se hizo click puede desaparecer a mitad del evento.
trackByProductId(index: number, item: any): any {
  return item?.productId ?? index;
}

trackByIndex(index: number): number {
  return index;
}

subscribeReloadSearch(): void {
  if(this.origin != 'RENT-A-CAR'){
    this.reloadAgainSubject.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      if (value && !this.lastPollFailed) {
         this.processSearchReload();
        if(this.filterActivated) {
          this.applyAllFilters();
        }
      }
    });
    this.reloadAgain = true;
    this.reloadAgainSubject.next(this.reloadAgain);
  }
}

/**
 * Procesa la recarga de la búsqueda.
 */
processSearchReload(): void {
  if (!this.reloadAgain) {
    return;
  }
  this.reloadSearch(this.payload, true, false, false)
    .catch(() => { /* error ya loggeado en el handler de doPost; evitamos Uncaught (in promise) */ });
}

/**
 * Realiza una búsqueda garantizando que solo haya UNA activa a la vez
 */
/**
 * Realiza una búsqueda garantizando que solo haya UNA activa a la vez
 */
reloadSearch(payload: any, reload?: boolean, refresh?: boolean, forceNew: boolean = false): Promise<any> {

  this.lastPayload = payload;

  // SI ES FORCE NEW, CANCELAR TODO Y CREAR NUEVO
  if (forceNew) {


    // Cancelar búsqueda anterior si existe
    if (this.pendingSearch && this.searchReject) {
      this.searchReject('Cancelado por nueva búsqueda');
      this.pendingSearch = false; // ← FORZAR A FALSE
    }

    // Crear NUEVA promesa
    this.searchPromise = new Promise((resolve, reject) => {
      this.searchResolve = resolve;
      this.searchReject = reject;
    });

    this.pendingSearch = true;
    this.executeSearch(payload, reload, refresh, true);

    return this.searchPromise;
  }

  // SOLO PARA NO FORCE NEW
  if (this.pendingSearch && this.searchPromise) {
    return this.searchPromise;
  }

  this.searchPromise = new Promise((resolve, reject) => {
    this.searchResolve = resolve;
    this.searchReject = reject;
  });

  this.pendingSearch = true;
  this.executeSearch(payload, reload, refresh, false);

  return this.searchPromise;
}


/**
 * Ejecuta la búsqueda real
 */
private executeSearch(payload: any, reload?: boolean, refresh?: boolean, forceNew: boolean = false): void {
  // SI ES FORCE NEW, IGNORAR TODAS LAS CONDICIONES
  if (forceNew) {
    this.executeSearchForceNew(payload, reload, refresh);
    return;
  }

  // SOLO VERIFICAR PARA BÚSQUEDAS NORMALES
  const shouldCancel = this.noLoadingForModal || this.openModalResearch;

  if (shouldCancel) {
    this.pendingSearch = false;
    if (this.searchReject) {
      // this.searchReject('Búsqueda cancelada por condiciones');
      this.searchResolve = null;
      this.searchReject = null;
    }
    return;
  }

  this.executeSearchForceNew(payload, reload, refresh);
}

/**
 * Ejecuta la búsqueda sin condiciones (para forceNew)
 */
private executeSearchForceNew(payload: any, reload?: boolean, refresh?: boolean): void {
  this.arrivalDate = payload.arrivalDate;
  this.departureDate = payload.departureDate;

  if (reload === true) {
    this.resultReload = true;
  }




  this._restService.doPost("app", "search", payload).subscribe({
    next: (response: any) => {

        if (response &&
            response.results &&
            Array.isArray(response.results) &&
            response.results.length === 0) {
          this.handleNoResults();
          return;
        }

      const payloadActually = JSON.parse(localStorage.getItem('payload'));

      if (this.isResponseValid(response, payloadActually)) {
        this.lastPollFailed = false; // el último poll fue exitoso, ya podemos reactivar el polling si el mouse sale
        this.lastResponse = response;
        this.shouldUpdateUI(response, reload, refresh);
      } else {
        return;
      }
      // Programar siguiente verificación si es recarga
      if (reload) {
        this.scheduleNextCheck();
      }

      if (this.searchResolve) {
        this.searchResolve(response);
      }

      this.pendingSearch = false;
    },
    error: (error: HttpErrorResponse) => {
      console.error("Error en la búsqueda:", error);

      this.lastPollFailed = true;
      this.reloadIterations = 0;

      if (this.searchReject) {
        this.searchReject(error);
      }

      this.pendingSearch = false;

      if (!reload) {
        this._emitLoading(false);
      } else {
        this.reloadAgain = false;
        this.reloadAgainSubject.next(false);
      }
    },
    complete: () => {
      this.isSearchRunning = false;
    }
  });
}

/**
 * Verifica si la respuesta corresponde a la consulta actual
 */
private isResponseValid(response: any, requestPayload: any): boolean {
  // Caso 1: Verificar por destination
  const responseDestination = response?.results?.[0]?.destination;
  const expectedDestination = requestPayload[0]?.destination;

  if (responseDestination && expectedDestination) {
    return responseDestination === expectedDestination;
  }

  // Caso 2: Verificar por hotels (búsqueda por hotel específico)
  const responseHotelId = response?.results?.[0]?.id;
  const expectedHotelId = requestPayload?.hotels?.[0];

  if (responseHotelId && expectedHotelId) {
    return responseHotelId === expectedHotelId;
  }

  return true;
}

onMouseEnter(event: MouseEvent): void {
  // const container = event.currentTarget as HTMLElement;
  // if (container && this.reloadAgain) {

  //   this.pausedByMouseEnter = true;
  //   this.reloadAgain = false;
  //   this.reloadAgainSubject.next(false);
  //   this.textBarCharge = 'Carga frenada por selección';

  //   // Cancelar cualquier búsqueda pendiente
  //   if (this.pendingSearch && this.searchReject) {
  //     this.searchReject('Cancelado por mouse enter');
  //   }
  // }
}

onMouseLeave(event: MouseEvent): void {
  const container = event.currentTarget as HTMLElement;
  const relatedTarget = event.relatedTarget as HTMLElement;
  const modalPresent = document.querySelector('mat-dialog-container');

  if (relatedTarget && (container.contains(relatedTarget) || modalPresent) && this.finishReload === false) {
    this.reloadAgain = false;
    this.reloadAgainSubject.next(false);
    this.noLoadingForModal = true;
    this.textBarCharge = 'Carga frenada por selección';

    if (this.pendingSearch && this.searchReject) {
      try {
        this.searchReject('Cancelado por modal');
      } catch (e) {
        // Ignorar error, ya está cancelado
      }
      this.pendingSearch = false;
    }
    return;
  }

  // if (this.pausedByMouseEnter) {
    this.noLoadingForModal = false;
    this.pausedByMouseEnter = false;

    if (!this.finishReload && !this.lastPollFailed) {
      this.reloadAgain = true;
      this.reloadAgainSubject.next(true);
      this.textBarCharge = 'Cargando más resultados...';

      // Ejecutar una verificación ahora que el mouse salió
      this.scheduleNextCheck();
    }
  // }
}

/**
 * Determina si debemos actualizar la UI basado en la respuesta
 */
private shouldUpdateUI(response: any, reload?: boolean, refresh?: boolean): void {
  // No actualizar si hay condiciones que lo impiden
  if (this.noLoadingForModal || this.openModalResearch) {
    return;
  }

  if (response &&
      response.results &&
      Array.isArray(response.results) &&
      response.results.length === 0) {
    this.handleNoResults();
    return;
  }

  if (this.page === 1) {
    const currentCount = response.results.length;
    this.totalResponse = { ...currentCount };
    this.results = response.results;

    if (this.results.length > 0) {
      this.filterResults();

      if (reload) {
        this.handleReload(response, currentCount);
      } else {
        this._emitLoading(false);
        this.itineraryService.notifyModalClosed(false);
      }

      this.resultsAux = [...this.results];
      this.resultTotal = this.results.length;
      this._emitLoading(false);
      this.itineraryService.notifyModalClosed(false);
      this.reloadSearching = false;
    }
  }

  if (this.page > 1) {
    this.completeLoading();
  }
}

/**
 * Maneja la lógica de recarga
 */
private handleReload(response: any, currentCount: number): void {
  // Si es la primera vez, guardamos el conteo y seguimos
  if (this.lastResultsCount === null) {
    this.lastResultsCount = currentCount;
    this.scheduleNextCheck();
    return;
  }

  // Si el conteo cambió, actualizamos y seguimos
  if (currentCount !== this.lastResultsCount) {
    this.lastResultsCount = currentCount;

    if (this.reloadIterations >= this.MAX_RELOAD_ITERATIONS) {
      this.completeLoading();
      return;
    }

    this.scheduleNextCheck();
    return;
  }

  this.completeLoading();
}

/**
 * Programa la siguiente verificación de cambios - SIN TIMEOUT
 */
/**
 * Programa la siguiente verificación de cambios - SIN TIMEOUT
 */
private scheduleNextCheck(): void {
  // CONTROL ANTI-BUCLE: Verificar tiempo mínimo entre verificaciones
  const now = Date.now();
  if (now - this.lastCheckTime < this.MIN_CHECK_INTERVAL) {
    return;
  }

  // Si ya hay una verificación programada, no hacer nada
  if (this.nextCheckScheduled) {
    return;
  }

  this.nextCheckScheduled = true;
  this.lastCheckTime = now;

  // Usar Promise.resolve para "programar" sin timeout
  Promise.resolve().then(() => {
    this.nextCheckScheduled = false;
    this.reloadIterations++; // contamos este poll para aplicar el cap duro en handleReload

    // Verificar condiciones antes de ejecutar
    if (this.shouldCheckForUpdates()) {
      // Ejecutar búsqueda y comparar resultados
      this.reloadSearch(this.lastPayload, true, false, false)
        .then((newResponse) => {
          this.compareAndUpdateResults(newResponse);
        })
        .catch((error) => {
          // En caso de error, no reprogramar inmediatamente
          setTimeout(() => {
            if (!this.finishReload && !this.lastPollFailed) {
              this.scheduleNextCheck();
            }
          }, 2000);
        });
    } else {
      setTimeout(() => {
        if (!this.finishReload && !this.lastPollFailed) {
          this.scheduleNextCheck();
        }
      }, 2000);
    }
  });
}

/**
 * Verifica si debemos chequear updates
 */
private shouldCheckForUpdates(): boolean {
  return !this.pausedByMouseEnter &&
         !this.openModalResearch &&
         !this.noLoadingForModal &&
         !this.finishReload;
}

/**
 * Compara resultados y actualiza si hay cambios
 */
private compareAndUpdateResults(newResponse: any): void {
  if (!this.lastResponse) return;

  const newResults = newResponse.results || [];
  const newCount = newResults.length;

  if (this.lastResultsCount === null) {
    this.lastResultsCount = newCount;
    this.shouldUpdateUI(newResponse, true);
    this.lastResponse = newResponse;
    return;
  }

  if (newCount !== this.lastResultsCount) {
    this.lastResultsCount = newCount;
    this.shouldUpdateUI(newResponse, true);
    this.lastResponse = newResponse;
  } else {
    this.completeLoading();
  }
}

/**
 * Completa el proceso de carga
 */
private completeLoading(): void {
  this.reloadAgain = false;
  this.finishReload = true;
  this.reloadAgainSubject.next(false);
  this.textBarCharge = 'Carga de resultados completada';
  this.lastResultsCount = null;
  this.reloadIterations = 0;
  this.lastPollFailed = false;
  this.pendingSearch = false;
  this.searchPromise = null;
  this.searchResolve = null;
  this.searchReject = null;
  this.nextCheckScheduled = false;
}

/**
 * Determina si la carga debe completarse (sin máximo de resultados)
 */
cancelResearch(resultsLength: number): boolean {
  return resultsLength === 0;
}
/**
 * Pausa manualmente el proceso de recarga.
 *
 * Actualiza `reloadAgain` y detiene la recarga activa.
 */
stopResearch(): void {
  this.pausedByMouseEnter = true;
  this.reloadAgain = false;
  this.reloadAgainSubject.next(false);
  this.textBarCharge = 'Carga frenada por selección';
  // console.log('Recarga pausada');
}

/**
 * Retoma la recarga si estaba pausada.
 *
 * Cambia el estado de `reloadAgain` y actualiza la barra de carga.
 */
startReSearch(): void {
  this.reloadAgain = true;
  if (this.reloadAgain) {
    this.noLoadingForModal = false;
    this.pausedByMouseEnter = false;
    this.reloadAgainSubject.next(true);
    this.textBarCharge = 'Cargando más resultados...';
    // console.log('Recarga por cierre de modal');
  }
}

/**
 * Gestiona la lógica al cerrar un modal, reanudando o finalizando la recarga.
 *
 * Si no hay recarga finalizada, retoma la búsqueda; de lo contrario, la finaliza.
 *
 * @param event -> Evento relacionado con el cierre del modal.
 */
modalClosedemitter(event: any): void {
  if(this.origin === 'HOTELS') {

    if (this.reloadAgain && this.finishReload === false) {
     this.startReSearch();
    } else {
      this.reloadAgain = false;
      this.finishReload = true;
      this.reloadAgainSubject.next(false);
      // console.log('Finalizado con cierre de modal');
      this.textBarCharge = 'Carga de resultados completada';
    }
  }
  if(this.origin === 'TRANSPORTS') {
    if(event === 'add') {
      if (this.itineraryService.hasBackupResults()) {

        // Usar el método del servicio que restaura solo los vehicles
        this.resultPaged = this.itineraryService.restoreVehiclesToResults(this.resultPaged);


      } else {
      }
    }
    if(event === 'close') {
      if (this.itineraryService.hasBackupResults()) {

        // Usar el método del servicio que restaura solo los vehicles
        this.resultPaged = this.itineraryService.restoreVehiclesToResults(this.resultPaged);


      } else {
      }
    }
  }

}


  /**
   * Valida los resultados según la categoría seleccionada.
   *
   * Si la categoría es hotel (id 1), ajusta los resultados y el estado de visibilidad de íconos.
   * Si no, verifica si los resultados están vacíos y ajusta los íconos en consecuencia.
   *
   * @results -> arreglo de resultados que se muestra en pantalla.
   * @resultTotal -> cantidad total de resultados.
   * @booleanHideIcons -> estado para ocultar o mostrar íconos.
   */
  handleCategoryValidation(): void {
    if (this.categoryId === 1) {
      this.deleteResponsePropertiesHotel(); // elimina varias propiedades específicas del objeto `results`
      this.resultsAux = [...this.results];
      this.resultTotal = this.results.length;
      this.booleanHideIcons = false;

    }
    if(this.categoryId === 2){
      this.resultsAux = [...this.results];
      this.resultTotal = this.results.length;
      this.booleanHideIcons = false;
    }
    if(this.categoryId === 6) {
      this.deleteResponsePropertiesTours();
    }
    if (this.categoryId === 8) {
      this.deleteResponsePropertiesTransports();
      this.resultsAux = [...this.results];
      this.resultTotal = this.results.length;
      this.booleanHideIcons = false;
    }
    if(this.categoryId === 10) {
      this.deleteResponsePropertiesInsurance();
    }
    else {
      if (this.results.length == 0) {

        this.booleanHideIcons = true;
      }
      this.resultsAux = this.results;
      this.resultTotal = this.results.length;
    }


    if(this.results && this.results.noResultMessage) {
      this.reloadAgain = false;
      this.finishReload = true;
      this.reloadAgainSubject.next(false);
      if (this.bsModalRef) {
        this.bsModalRef.hide();
      }
      const initialState: ModalOptions = {
        initialState: {
          data: 'No se encontraron datos, para los parámetros suministrados'
        }
      }
      const modalOptions = Object.assign({}, initialState, this.config);
      this.bsModalRef = this.modalService.show(MaterialModalAlertComponent,  modalOptions);

        this.confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
          if(result) {
            this.route.navigate(['/home']);
          }
        });
    } else {
      // this.setProfitability(this.results);
      this.createFilter();
      if(this.categoryId === 1 || this.categoryId === 10) {
        this.subscribeReloadSearch();
      }
      this.configureCategorySpecificActions(); // Acciones según la categoría (HOTEL o RENT-A-CAR)
      this.prepareResultsForFilter(); // Preparar resultados y aplicar filtros
      if(this.userService?.itineraryActive[0]?.currency) {
        this.resultTotal = this.results.length;
      }
    }
  }


  // Marca, sobre los resultados en sí (mismos objetos que consume la card
  // vía resultPaged), cuál es el más rápido y cuál el más económico —
  // reutiliza los mismos helpers que ya arman los filtros de vuelo.
  private tagFlightBadges(flights: any[]): void {
    if (!flights || flights.length === 0) {
      return;
    }

    const fastest = flights.reduce((min, flight) =>
      getFlightTotalDurationHours(flight) < getFlightTotalDurationHours(min) ? flight : min
    );
    const cheapest = flights.reduce((min, flight) =>
      getFlightPrice(flight) < getFlightPrice(min) ? flight : min
    );

    flights.forEach((flight: any) => {
      flight.isFastest = flight === fastest;
      flight.isCheapest = flight === cheapest;
    });
  }

  private createFilter(): void {
    switch(this.categoryId) {
      case 1:
        this.mealsFilter = createMealsFilter(this.results);
        this.amenitiesFilter = createAmenitiesFilter(this.results);
        break;
      case 2:
        this.luggageFilter = createLuggageFilter(this.results);
        this.acrissFilter = createAcrissFilter(this.results);
        if(this.acrissFilter?.length > 0){
          setTimeout(() => {
            this.resultsRentacarAcriss.emit(this.acrissFilter);
          });
        }
        this.supplierContractRentACarFilter = createContractRentACar(this.results);
        this.transmissionFilter = createTransmisionFilter(this.results);
        this.quantityDoorsFilter = createDoorsFilter(this.results);
        this.quantityMaxPassengerFilter = createQtyMaxPassenger(this.results);
        break;
      case 6:
        this.languageFilter = createLanguageFilterTour(this.results);
        this.sessionsFilter = createSessionsFilter(this.results);
        this.amenitiesFilter = createAmenitiesFilterTour(this.results);
        break;
      case 8:
        this.vehicleTypeFilter = createVehicleTypes(this.results);
        break;
      case 5:
        this.airlinesFilterFlights = createFlightAirlinesFilter(this.results);
        this.stopsFilterFlights = createFlightStopsFilter(this.results);
        this.cabinClassFilterFlights = createFlightCabinClassFilter(this.results);
        this.departureAirportsFilterFlights = createFlightDepartureAirportsFilter(this.results);
        this.departureTimeFilterFlights = createFlightTimeFilter(this.results, 'departure');
        this.arrivalTimeFilterFlights = createFlightTimeFilter(this.results, 'arrival');
        this.flightAttributesFilter = createFlightAttributesFilter(this.results);

        const flightDurations = this.results.map((flight: any) => getFlightTotalDurationHours(flight)).filter((hours: number) => hours > 0);
        this.flightDurationRangeHours = {
          min: flightDurations.length ? Math.floor(Math.min(...flightDurations)) : 0,
          max: flightDurations.length ? Math.ceil(Math.max(...flightDurations)) : 48
        };
        this.selectedMaxDurationHoursFlights = this.flightDurationRangeHours.max;
        this.optionsSliderDuration = {
          floor: this.flightDurationRangeHours.min,
          ceil: this.flightDurationRangeHours.max,
          hidePointerLabels: true,
          hideLimitLabels: true
        };
        this.tagFlightBadges(this.results);
        break;
      case 10:
        this.modalityFilter = createModalityInsuranceFilter(this.results);
        this.coverageFilter = createCoverageInsuranceFilter(this.results);
        this.upgradesFilter = createUpgradeInsuranceFilter(this.results);
        break;
    }
  }

  /**
 * @method deleteResponsePropertiesHotel
 *
 * @description
 * Este método elimina varias propiedades específicas del objeto `results`. Las propiedades eliminadas son las que contienen datos relacionados con la búsqueda y respuesta del hotel, como la fecha de llegada, la categoría del hotel, el destino, y otros detalles adicionales.
 *
 * @returns {void}
 * No retorna ningún valor.
 *
 * @example
 * Llamada al método para eliminar propiedades innecesarias de un objeto de resultados
 * this.deleteResponsePropertiesHotel();
 *
 */
  deleteResponsePropertiesHotel(): void{
    delete this.results['arrivalDate'];
    // delete this.results['categoryName'];
    delete this.results['destination'];
    delete this.results['others'];
    delete this.results['payload'];
    delete this.results['qtyPax'];
    delete this.results['searchId'];
    delete this.results['form'];
  }

  deleteResponsePropertiesTransports(): void {
    this.searchId = this.results['searchId'];
    // console.log(this.searchId)
    delete this.results['arrivalDate'];
    delete this.results['destination'];
    delete this.results['others'];
    delete this.results['payload'];
    delete this.results['qtyPax'];
    delete this.results['searchId'];
    delete this.results['form'];
  }

    deleteResponsePropertiesTours(): void {
    this.searchId = this.results['searchId'];
    // console.log(this.searchId)
    delete this.results['arrivalDate'];
    delete this.results['destination'];
    delete this.results['others'];
    delete this.results['payload'];
    delete this.results['qtyPax'];
    delete this.results['searchId'];
    delete this.results['form'];
    this.results['categoryName'] = 'TOURS';
  }

  deleteResponsePropertiesInsurance(): void {
    this.searchId = this.results['searchId'];
    // console.log(this.searchId)
    delete this.results['arrivalDate'];
    delete this.results['destination'];
    delete this.results['others'];
    delete this.results['payload'];
    delete this.results['qtyPax'];
    delete this.results['searchId'];
    this.results['categoryName'] = 'INSURANCE';
  }

  /**
   * Inicializa los filtros de Rent-a-Car.
   *
   * Este método resetea las listas de selección de categoría y marca en la búsqueda de Rent-a-Car.
   *
   * @filtersRentacar.category.checkedArray -> lista de categorías seleccionadas.
   * @filtersRentacar.brand.checkedArray -> lista de marcas seleccionadas.
   */
  initializeRentacarFilters(): void {
    this.filtersRentacar.category.checkedArray = [];
    this.filtersRentacar.brand.checkedArray = [];
  }

  /**
   * Ordena los resultados por precio más bajo.
   *
   * Si la variable `orderPriceby` tiene el valor "priceLow", se llama al método `orderPriceLow`
   * para ordenar los resultados por precio ascendente.
   *
   * @orderPriceby -> parámetro que determina si los resultados deben ser ordenados por precio.
   */
  handleOrderByPriceLow(): void {
    if (this.orderPriceby == "priceLow") {
      this.orderPriceLow();
    }
  }

  /**
   * Configura acciones específicas basadas en la categoría seleccionada.
   *
   * Dependiendo del id de la categoría (`categoriesId`), se ejecutan funciones específicas:
   * - HOTEL (id 1): no realiza acciones adicionales.
   * - RENT-A-CAR (id 2): llama al método `setCarGroup`.
   *
   * @payload.categoriesId -> lista de ids de categorías.
   */
  configureCategorySpecificActions(): void {
    switch (this.categoryId) {
      case 1: // HOTEL
        break;
      case 2:  // RENT-A-CAR
        this.setCarGroup();
        break;
      default:
        break;
    }
  }

  /**
   * Prepara los resultados para aplicar filtros.
   *
   * Este método prepara los resultados, aplicando filtros y obteniendo el total de resultados.
   * Además, si los resultados no son nulos o indefinidos, se aplica un filtro adicional y se
   * obtienen los precios mínimos y máximos.
   *
   * @resultsFilter -> resultados filtrados para ser mostrados.
   * @total -> total de resultados.
   */
  prepareResultsForFilter(): void {
    this.resultsFilter = {...this.results};

    if (this.results !== undefined && this.results !== null) {
      this._total = this.results.length;
      this.resetFilter();
      this.searchFilter();
      this.searchPriceLowAndHigh();
      this.filterResults();
    }
  }

  /**
 * Método para alternar la visualización de filtros.
 *
 * Este método invierte el estado de la variable `showFilters` para mostrar u ocultar los filtros.
 */
toggleFilters() {
  this.showFilters = !this.showFilters;
}

applyAllFilters(): void {
  if (!this.resultsAux) {
    return;
  }
  let filtered = [...this.resultsAux];
  this.filterActivated = true;
  const categoryId = String(this.payload?.categoriesId?.[0] || '');


  switch(categoryId) {
    case '1':
              // 1. Filtrar por texto
              if (this.text && this.text.trim() !== '') {
                const textLower = this.text.toLowerCase();
                filtered = this.titleFilter.transform(filtered, textLower);
              }

              if(filtered && filtered.length > 1) {
              // 2. Filtrar por precio
              filtered = this.sliderFilter.transform(filtered, this.filterLowPrice, this.filterHighPrice, categoryId);
              }
              // 3. Filtrar por estrellas
              if (this.selectedStars > 0) {
                filtered = filtered.filter(item => {
                  const star = parseFloat(item.additionalInfo?.starRating);
                  return !isNaN(star) && star === this.selectedStars + 1;
                });
              }

              // 4. Filtrar por tipo de tarifa
            if (this.selectedRateTypes.length > 0) {
              filtered = filtered.map(item => {
                const rooms = item.additionalInfo?.rooms || [];
                const filteredRooms = rooms.filter(room =>
                  this.selectedRateTypes.includes(room.room?.rateClass)
                );
                return {
                  ...item,
                  additionalInfo: {
                    ...item.additionalInfo,
                    rooms: filteredRooms
                  }
                };
              }).filter(item => item.additionalInfo.rooms.length > 0); // eliminás items sin rooms válidos
            }

              // 5. Filtrar por régimen
              if (this.selectedBoardKeys.length > 0) {
              // Aseguramos que todo esté en lowercase para comparar correctamente
              const selectedBoards = this.selectedBoardKeys.map(b => b.toLowerCase());

              filtered = filtered.map(item => {
                const rooms = item.additionalInfo?.rooms || [];
                const filteredRooms = rooms.filter(room =>
                  selectedBoards.includes(room?.room?.boardName?.toLowerCase())
                );

                return {
                  ...item,
                  additionalInfo: {
                    ...item.additionalInfo,
                    rooms: filteredRooms
                  }
                };
              }).filter(item => item.additionalInfo.rooms.length > 0);
              }
              // 6. Filtrar por amenities
              if (this.selectedAmenityKeywords.length > 0) {

                const selectedLower = this.selectedAmenityKeywords.map(k => k.toLowerCase());


                  filtered = filtered.filter(item => {
                    const amenities = item.additionalInfo?.amenities?.map(a => a.amenity_name.toLowerCase()) || [];
                    return selectedLower.some(keyword =>
                      amenities.some(a => a.includes(keyword))
                    );
                  });
                }
      break;
    case '2': //Rent-a-car
         filtered = filtered.filter(
        (data, index, j) => index === j.findIndex((t) => t.title == data.title && t.providerName == data.providerName)
        );

      if(filtered && filtered.length > 0){
        if (this.luggageSelected.length > 0) {
        filtered = filtered.filter((item) => {
          return this.luggageSelected.includes(item.additionalInfo.carRental.bagsQuantity);
        });
      }

      if(this.acrissSelected.length > 1){
          filtered = filtered.filter((item) => {
          return this.acrissSelected.includes(item.additionalInfo.carRental.AcrissCode[0]);
        });
      }

      if(this.maxPaxSelected.length > 0) {
        filtered = filtered.filter((item) => {
          return this.maxPaxSelected.includes(item.additionalInfo.carRental.paxQuantity);
        })
      }
      }

      if(this.supplierRentACarSelected.length > 0) {
        filtered = filtered.filter((item) => {
          return this.supplierRentACarSelected.includes(item.additionalInfo.carRental?.optionRates?.suplier?.name);
        })
      }




    break;
    case '6':

      // 1. Filtrar por texto
              if (this.text && this.text.trim() !== '') {
                const textLower = this.text.toLowerCase();
                filtered = this.titleFilter.transform(filtered, textLower);
              }
      if(filtered && filtered.length > 1) {
                if (this.selectedAmenityKeywords.length > 0) {

                  const selectedLower = this.selectedAmenityKeywords.map(k => k.toLowerCase());


                    filtered = filtered.filter(item => {

                      const amenities = item.additionalInfo?.tours.amenities?.map(a => a.description.toLowerCase()) || [];
                      return selectedLower.some(keyword =>
                        amenities.some(a => a.includes(keyword))
                      );
                    });
                  }
                    if (this.selectedRateTypes.length > 0) {
                      filtered = filtered.map(item => {
                        const tours = item.additionalInfo?.tours.options || [];

                        const filteredRooms = tours.filter(tour =>

                          this.selectedRateTypes.includes(tour.rateClass)
                        );
                        return {
                          ...item,
                          additionalInfo: {
                            ...item.additionalInfo,
                            tours: {
                              options: filteredRooms
                            }
                          }
                        };
                      }).filter(item => item.additionalInfo.tours.options.length > 0); // eliminás items sin rooms válidos
                    }

            filtered = filterDynamic(filtered, this.filter, this.filterLowPrice, this.filterHighPrice, categoryId, this.sliderFilter);

          }


    break;

    case '8':
    // 8. Filtrar por tipo de vehículo
    if(filtered && filtered.length > 1) {

      filtered = filterDynamic(filtered, this.filter, this.filterLowPrice, this.filterHighPrice, categoryId, this.sliderFilter);
    }

      break;

    case '10':
                    // 1. Filtrar por texto
              if (this.text && this.text.trim() !== '') {
                const textLower = this.text.toLowerCase();
                filtered = this.titleFilter.transform(filtered, textLower);
              }

              if(filtered && filtered.length > 1) {
              // 2. Filtrar por precio
              filtered = this.sliderFilter.transform(filtered, this.filterLowPrice, this.filterHighPrice, categoryId);
              }
      break;

    case '5': // FLIGHTS
      if (this.selectedAirlinesFlights.length > 0) {
        filtered = filtered.filter((flight: any) => {
          const code = flight?.itinerary?.[0]?.options?.[0]?.segments?.[0]?.airline?.code || flight?.fare?.validatingCarrier;
          return this.selectedAirlinesFlights.includes(code);
        });
      }

      if (this.selectedStopsFlights.length > 0) {
        filtered = filtered.filter((flight: any) => {
          const segments = flight?.itinerary?.[0]?.options?.[0]?.segments || [];
          const stops = segments.length - 1;
          return this.selectedStopsFlights.some(key => {
            if (key === 'directo') return stops === 0;
            if (key === 'unaEscala') return stops === 1;
            if (key === 'dosMasEscalas') return stops >= 2;
            return false;
          });
        });
      }

      if (this.selectedCabinClassesFlights.length > 0) {
        filtered = filtered.filter((flight: any) => {
          const cabinClass = (flight?.itinerary?.[0]?.options?.[0]?.segments?.[0]?.cabin?.class || flight?.fare?.brandName || '').toString().toLowerCase().trim();
          return this.selectedCabinClassesFlights.includes(cabinClass);
        });
      }

      if (this.selectedDepartureAirportsFlights.length > 0) {
        filtered = filtered.filter((flight: any) => {
          const airport = flight?.itinerary?.[0]?.options?.[0]?.segments?.[0]?.departure?.airport;
          return this.selectedDepartureAirportsFlights.includes(airport);
        });
      }

      if (this.selectedDepartureTimeFlights.length > 0) {
        filtered = filtered.filter((flight: any) => {
          const dateTime = flight?.itinerary?.[0]?.options?.[0]?.segments?.[0]?.departure?.dateTime;
          return this.selectedDepartureTimeFlights.includes(getFlightTimeBucketKey(dateTime));
        });
      }

      if (this.selectedArrivalTimeFlights.length > 0) {
        filtered = filtered.filter((flight: any) => {
          const segments = flight?.itinerary?.[0]?.options?.[0]?.segments || [];
          const dateTime = segments[segments.length - 1]?.arrival?.dateTime;
          return this.selectedArrivalTimeFlights.includes(getFlightTimeBucketKey(dateTime));
        });
      }

      if (this.selectedMaxDurationHoursFlights !== null && this.selectedMaxDurationHoursFlights < this.flightDurationRangeHours.max) {
        filtered = filtered.filter((flight: any) => getFlightTotalDurationHours(flight) <= this.selectedMaxDurationHoursFlights);
      }

      if (this.selectedFlightAttributes.length > 0) {
        filtered = filtered.filter((flight: any) =>
          this.selectedFlightAttributes.every(attribute => flightHasAttribute(flight, attribute))
        );
      }

      if (filtered && filtered.length > 1) {
        filtered = this.sliderFilter.transform(filtered, this.filterLowPrice, this.filterHighPrice, categoryId);
      }
      break;

  }

  // 7. Resultado final
  this.results = filtered;
  if (this.results.length > 0) {
    this.hasExecutedElse = false;
    this.filterResults();
    // this.searchPriceLowReload();
    // this.recreateSlider();
    // this.validTotalPrice();
    // this.customizeSlider();
  } else {
    this.noResultsFilter();
  }
}

recreateSlider() {
  // Guardar valores actuales
  const currentValue = this.filterLowPrice;
  const currentHighValue = this.filterHighPrice;

  // Resetear valores temporalmente
  this.filterLowPrice = 0;
  this.filterHighPrice = 0;

  // Forzar detección de cambios
  setTimeout(() => {
    this.filterLowPrice = currentValue;
    this.filterHighPrice = currentHighValue;
  }, 0);
}


/**
* Emisor de texto para aplicar filtros.
*
* Este método actualiza el valor de `text` y filtra los resultados
* con base en el texto proporcionado.
*
* @param text -> Texto utilizado para filtrar resultados.
*/
textEmitter(text: any) {
  this.text = text;
  this.applyAllFilters();
}


/**
* Genera una lista de íconos de estrellas.
*
* Este método crea un arreglo con la ruta de íconos de estrellas.
*
* @returns Lista de rutas de íconos de estrellas.
*/
stars() {
  const stars = [];
  for (let i = 0; i < 5; i++) {
      stars.push('/assets/icons/search-result/star.svg');
  }
  return stars;
}

// /**
// * Filtra resultados por clasificación de estrellas.
// *
// * Este método filtra los resultados según la calificación de estrellas seleccionada.
// * Si no se selecciona ninguna clasificación, muestra todos los resultados.
// *
// * @param selectedStars -> Número de estrellas seleccionadas.
// */
// filterStar(selectedStars: number) {
//   this.selectedStars = selectedStars;
//   this.applyAllFilters();
//   // this.applyStarFilter(-1);
// }

filterStar(selectedStars: number) {
  // Si clickea la misma estrella que ya estaba seleccionada, deselecciona
  if (this.selectedStars === selectedStars + 1) {
    this.selectedStars = -1;  // Deseleccionar todas
  } else {
    this.selectedStars = selectedStars;  // selectedStars = 1,2,3,4,5
  }
  this.applyAllFilters();
}


filterTypeRate(checked: boolean, typeRate: string): void {
  this.selectedRateTypes = checked
    ? [...this.selectedRateTypes, typeRate]
    : this.selectedRateTypes.filter(rt => rt !== typeRate);

  this.applyAllFilters();
}

filterTypeBoardName(checked: boolean, key: string): void {

  const validMatches = this.mealsFilter.find(b => b.key === key)?.matches.map(m => m.toLowerCase()) || [];

  if (checked) {
    this.selectedBoardKeys.push(...validMatches);
  } else {
    this.selectedBoardKeys = this.selectedBoardKeys.filter(k => !validMatches.includes(k));
  }
  this.applyAllFilters();
}

  /**
  * Filtra resultados por amenidades.
  *
  * Este método permite agregar o quitar amenidades a la lista de filtros activos
  * y ajusta los resultados en consecuencia.
  *
  * @param event -> Estado del checkbox para una amenidad (true o false).
  * @param amenitie -> Nombre de la amenidad a filtrar.
  */
  filterAmenities(checked: boolean, key: string): void {
    const validMatches = this.amenitiesFilter.find(b => b.key === key)?.matches.map(m => m.toLowerCase()) || [];

  if (checked) {
    this.selectedAmenityKeywords.push(...validMatches);
  } else {
    this.selectedAmenityKeywords = this.selectedAmenityKeywords.filter(v => !validMatches.includes(v));
  }

  this.applyAllFilters();
}

filterFx(checked: boolean, key: string, filterSource: any[], path: string, entityKey: string): void {


  if(path === 'sessions') {
      this.filterSessionsByPeriod(checked, key, filterSource, path, entityKey);
  } else {
    const validMatches: string[] = filterSource.find(v => v.key === key)?.matches.map(m => m.toLowerCase()) || [];


    if (checked) {
      this.filter.push({
        path, values: validMatches, entityKey: entityKey,
        value: undefined
      });
    } else {
      this.filter = this.filter.filter(f => {
        return f.path !== path || !f.values.some(v => validMatches.includes(v));
      });
    }
  }
  this.applyAllFilters();

}

filterSessionsByPeriod(checked: boolean, period: string, filterSource: any[], path: string, entityKey: string): void {
  if (checked) {
    this.filter.push({
      path,
      values: [period.toLowerCase()],
      entityKey: entityKey,
      // Agregamos una propiedad custom para indicar que es filtro por período
      isPeriodFilter: true,
      value: undefined
    });
  } else {
    this.filter = this.filter.filter(f =>
      !(f.path === path && f.values.includes(period.toLowerCase()))
    );
  }
}


filterLuggage(check:any, type:any):void{
  let validMatches:any[] = this.luggageFilter.find(luggage => luggage.key === type)?.matches ||  [];


  if(check){
      this.luggageSelected.push(...validMatches);
  }else{
    this.luggageSelected = this.luggageSelected.filter(luggage => !validMatches.includes(luggage))
  }

  this.applyAllFilters();
}

filterAcriss(check:any, type:any):void{
  let validMatches:any[] = this.acrissFilter.find(typeAcriss => typeAcriss.key === type)?.matches ||  [];

  if(check){
    this.acrissSelected.push(...validMatches);
  }else{
    this.acrissSelected = this.acrissSelected.filter(acriss => !validMatches.includes(acriss))
  }

  this.applyAllFilters();
}

filterSuplierRentACar(check:any, type:any):void{
  let validMatches:any[] = this.supplierContractRentACarFilter.find(suplier => suplier.key === type)?.matches ||  [];

  if(check){
    this.supplierRentACarSelected.push(...validMatches);
  }else{
    this.supplierRentACarSelected = this.supplierRentACarSelected.filter(acriss => !validMatches.includes(acriss))
  }

  this.applyAllFilters();
}

filterTransmission(check:any, type:any):void{
  let validValueTransmission:any[] = this.transmissionFilter.find(transmission => transmission.key === type)?.matches || [];

  if(check){
    this.transmissionSelected.push(...validValueTransmission);
  }else{
    this.transmissionSelected = this.transmissionFilter.filter(transmission => !validValueTransmission.includes(transmission))
  }

  this.applyAllFilters();
}

filterDoors(check:any, type:any):void{
  let validDoorsArray:any[] = this.quantityDoorsFilter.find(door => door.key === type)?.matches || [];

  if(check){
    this.doorsSelected.push(...validDoorsArray);
  }else{
    this.doorsSelected = this.doorsSelected.filter(door => !validDoorsArray.includes(door))
  }

  this.applyAllFilters();
}

filterMaxPassenger(check:any, type:any):void{
  let validPaxArray:any[] = this.quantityMaxPassengerFilter.find(maxPax => maxPax.key === type)?.matches || [];

  if(check){
    this.maxPaxSelected.push(...validPaxArray);
  }else{
    this.maxPaxSelected = this.maxPaxSelected.filter(pax => !validPaxArray.includes(pax))
  }

  this.applyAllFilters();
}

// VUELOS

toggleFlightAirline(checked: boolean, code: string): void {
  this.selectedAirlinesFlights = checked
    ? [...this.selectedAirlinesFlights, code]
    : this.selectedAirlinesFlights.filter(c => c !== code);
  this.applyAllFilters();
}

toggleFlightStops(checked: boolean, key: string): void {
  this.selectedStopsFlights = checked
    ? [...this.selectedStopsFlights, key]
    : this.selectedStopsFlights.filter(k => k !== key);
  this.applyAllFilters();
}

toggleFlightCabinClass(checked: boolean, key: string): void {
  this.selectedCabinClassesFlights = checked
    ? [...this.selectedCabinClassesFlights, key]
    : this.selectedCabinClassesFlights.filter(k => k !== key);
  this.applyAllFilters();
}

toggleFlightDepartureAirport(checked: boolean, key: string): void {
  this.selectedDepartureAirportsFlights = checked
    ? [...this.selectedDepartureAirportsFlights, key]
    : this.selectedDepartureAirportsFlights.filter(k => k !== key);
  this.applyAllFilters();
}

toggleFlightDepartureTime(key: string): void {
  this.selectedDepartureTimeFlights = this.selectedDepartureTimeFlights.includes(key)
    ? this.selectedDepartureTimeFlights.filter(k => k !== key)
    : [...this.selectedDepartureTimeFlights, key];
  this.applyAllFilters();
}

toggleFlightArrivalTime(key: string): void {
  this.selectedArrivalTimeFlights = this.selectedArrivalTimeFlights.includes(key)
    ? this.selectedArrivalTimeFlights.filter(k => k !== key)
    : [...this.selectedArrivalTimeFlights, key];
  this.applyAllFilters();
}

toggleFlightAttribute(checked: boolean, key: string): void {
  this.selectedFlightAttributes = checked
    ? [...this.selectedFlightAttributes, key]
    : this.selectedFlightAttributes.filter(k => k !== key);
  this.applyAllFilters();
}


/**
 * Método para aplicar o remover filtros según la interacción del usuario.
 *
 * Dependiendo de la categoría seleccionada, actualiza los filtros aplicados
 * y ajusta la lista de resultados visibles.
 *
 * @param event -> Objeto del evento que dispara la acción (click o slider).
 * @param value -> Valor del filtro seleccionado.
 * @param type -> Tipo de filtro aplicado (por ejemplo, categoría o precio).
 * @param _id -> Identificador único del filtro.
 * @selectedFilters -> Lista de filtros activos para rent-a-car.
 */
applyFilter(event: any, value: any, type: any, _id: any) {
  let selectedFiltersAux = [];
  let filter: any;
  const id = type + '_' + _id;
  if (event.target) {
      switch (String(this.payload?.categoriesId?.[0])) {
          case '1': // HOTEL
              if (event.target.checked) {
                  this.countFilterApply++;
              } else {
                  this.countFilterApply = Math.max(this.countFilterApply - 1, 0);
              }
              break;
          case '2': // RENT-A-CAR
              if (event.target.checked) {
                  filter = {
                      order: this.orderFilter + 1,
                      id: id,
                      type: type,
                      value: value
                  };
                  this.selectedFilters.push(filter);
                  this.filterResults();
              } else {
                  // selectedFiltersAux = this.selectedFilters.filter(element => element.id !== id);
                  // this.selectedFilters = selectedFiltersAux;
                  this.clearFilter();
              }
              break;
          case '6': // TRASLADO
              if (event.target.checked) {
                  this.countFilterApply++;
              } else {
                  this.countFilterApply = Math.max(this.countFilterApply - 1, 0);
              }
              break;
          case '8': // TRASLADO
              if (event.target.checked) {
                  this.countFilterApply++;
              } else {
                  this.countFilterApply = Math.max(this.countFilterApply - 1, 0);
              }
              break;
          case '10': // TRASLADO
              if (event.target.checked) {
                  this.countFilterApply++;
              } else {
                  this.countFilterApply = Math.max(this.countFilterApply - 1, 0);
              }
              break;
          default:
              break;
      }
  } else {
      switch (String(this.payload?.categoriesId?.[0])) {
          case '1': // Slider filter for hotel prices
              if (event.pointerType === 0) {
                  this.filters.lowPrice = event.value;
              } else {
                  this.filters.HighPrice = event.highValue;
              }
              this.applyAllFilters()
              break;
          case '6': // Slider filter for hotel prices
              if (event.pointerType === 0) {
                  this.filters.lowPrice = event.value;
              } else {
                  this.filters.HighPrice = event.highValue;
              }
              this.applyAllFilters()
              break;
          case '8': // Slider filter for hotel prices
              if (event.pointerType === 0) {
                  this.filters.lowPrice = event.value;
              } else {
                  this.filters.HighPrice = event.highValue;
              }
              this.applyAllFilters()
              break;
          case '10': // Slider filter for hotel prices
              if (event.pointerType === 0) {
                  this.filters.lowPrice = event.value;
              } else {
                  this.filters.HighPrice = event.highValue;
              }
              this.applyAllFilters()
              break;
          default:
              this.filterResults();
              break;
      }
  }
}


 /**
 * Busca la cantidad de veces que aparece un valor en los resultados según el tipo especificado.
 *
 * @param value -> Valor a buscar.
 * @param type -> Tipo de filtro (marca, categoría o tipo).
 * @returns Cantidad de elementos encontrados.
 */
getQtyItem(value: any, type: any) {
  let item: any = this.results;

  switch (String(type)) {
      case 'name': // Marca
          return item.filter(o => o.additionalInfo.carRental.optionRates.suplier.name === value).length;
      case 'category': // Categoría
          return item.filter(o => o.additionalInfo.carRental.category === value).length;
      case 'type': // Puerta
          return item.filter(o => o.additionalInfo.carRental.type === value).length;
      default:
          return 0;
  }
}

/**
* Obtiene la imagen o la cantidad de elementos según el valor y el tipo proporcionados.
*
* @param value -> Valor a buscar.
* @param type -> Tipo de filtro (marca, categoría o tipo).
* @returns Imagen o cantidad de elementos encontrados según el tipo.
*/
getImgItem(value: any, type: any) {
  let item: any = this.results;
  let imag: any;

  switch (String(type)) {
      case 'name': // Marca
          return item.filter(o => o.additionalInfo.carRental.optionRates.suplier.name === value);
      case 'category': // Categoría
          imag = item.filter(o => o.additionalInfo.carRental.category === value)
                     .map(res => res.additionalInfo.images[0].image)[0];
          return imag;
      case 'type': // Puerta
          return item.filter(o => o.additionalInfo.carRental.type === value).length;
      default:
          return null;
  }
}

/**
* Aplica los filtros y cuenta los productos según el tipo de búsqueda (hotel o rent-a-car).
*/
searchFilter() {
  this.resultFilterCount = [];
  this.totalProduct = 0;
  this.resultFilterCount = this.results;

  if (this.resultFilterCount.length > 0) {
      this.resultFilterCount.map(item => {
          switch (String(this.payload?.categoriesId?.[0])) {
              case '1': // Hotel
                  this.totalProduct++;
                  break;
              case '5': // Vuelos
                  this.totalProduct++;
                  break;
              case '2': // Rent-a-Car
                  // Filtrar por marca
                  if (item.additionalInfo.carRental.optionRates.suplier.name) {
                      this.filtersRentacar.brand.brandArray.push(item.additionalInfo.carRental.optionRates.suplier.name);
                      this.filtersRentacar.brand.brandArray = this.filtersRentacar.brand.brandArray.filter((item_, index) =>
                          this.filtersRentacar.brand.brandArray.indexOf(item_) === index
                      );
                  }
                  // Filtrar por categoría
                  if (item.additionalInfo.carRental.category) {
                      this.filtersRentacar.category.categoryArray.push(item.additionalInfo.carRental.category);
                      this.filtersRentacar.category.categoryArray = this.filtersRentacar.category.categoryArray.filter((item_, index) =>
                          this.filtersRentacar.category.categoryArray.indexOf(item_) === index
                      );
                  }
                  // Filtrar por tipo (puerta)
                  if (item.additionalInfo.carRental.type) {
                      this.filtersRentacar.type.typeArray.push(item.additionalInfo.carRental.type);
                      this.filtersRentacar.type.typeArray = this.filtersRentacar.type.typeArray.filter((item_, index) =>
                          this.filtersRentacar.type.typeArray.indexOf(item_) === index
                      );
                  }
                  this.totalProduct++;

                  // Buscar cantidad de marca
                  this.filtersRentacar.brand.brandArray.forEach((brand, index) => {
                      this.filtersRentacar.brand.brandCant[index] = this.getQtyItem(brand, 'name');
                  });

                  // Buscar cantidad de categoría y obtener imágenes
                  this.filtersRentacar.category.categoryArray.forEach((category, index) => {
                      this.filtersRentacar.category.categoryCant[index] = this.getQtyItem(category, 'category');
                      this.filtersRentacar.category.img[index] = this.getImgItem(category, 'category');
                  });

                  // Buscar cantidad de tipo (puerta)
                  this.filtersRentacar.type.typeArray.forEach((type, index) => {
                      this.filtersRentacar.type.typeCant[index] = this.getQtyItem(type, 'type');
                  });
                  break;
              case '6': // Hotel
                  this.totalProduct++;
                  break;
              case '8': // Hotel
                  this.totalProduct++;
                  break;
              case '10': // Hotel
                  this.totalProduct++;
                  break;
              default:
                  break;
          }
      });
  }

  // this.searchPriceLowReload();
}

/**
* Filtra un arreglo según los campos y valores proporcionados.
*
* @param array -> Arreglo a filtrar.
* @param fields -> Campos a evaluar.
* @param value -> Valores correspondientes a los campos.
* @returns Arreglo filtrado.
*/
filterArray(array: any, fields: any, value: any) {
  return array.filter(item => {
      return fields.every((field, index) => {
          if (field === 'name') {
              return item.additionalInfo.carRental.optionRates.suplier[field] === value[index];
          }
          if (field === 'category' || field === 'type') {
              return item.additionalInfo.carRental[field] === value[index];
          }
          return false;
      });
  });
}

/**
* Restaura los filtros a su estado inicial.
*/
resetFilter() {
  this.selectedAmenityKeywords = [];
  this.selectedRateTypes = [];
  this.countFilterApply = 0;
  this.selectedStars = 0;
  this.selectedFilters = [];
  this.resultFilterCount = [];
  this.selectedAmenities = [];
  this.filtersRentacar.category.checkedArray = [];
  this.filtersRentacar.brand.checkedArray = [];
  this.filtersRentacar.type.checkedArray = [];

  this.selectedAirlinesFlights = [];
  this.selectedStopsFlights = [];
  this.selectedCabinClassesFlights = [];
  this.selectedDepartureAirportsFlights = [];
  this.selectedDepartureTimeFlights = [];
  this.selectedArrivalTimeFlights = [];
  this.selectedFlightAttributes = [];
  this.selectedMaxDurationHoursFlights = this.flightDurationRangeHours?.max ?? null;

  if(this.origin === 'RENT-A-CAR') {
    this.setCarGroup();
  }
}

/**
 * Método para aplicar filtros a los resultados según el tipo de categoría.
 *
 * Este método gestiona la lógica de filtrado para diferentes categorías
 * (hotel y rent-a-car), ordena los resultados por precio y actualiza los datos visibles.
 *
 * @filterInitialized -> Indica si los filtros han sido inicializados.
 * @orderPriceby -> Ordena los resultados por precio ascendente o descendente.
 * @results -> Arreglo de resultados filtrados.
 * @selectedFilters -> Filtros seleccionados para rent-a-car.
 */
filterResults() {
  // console.log('filterRsults', this.orderPriceby);
  this.filterInitialized = true;
  switch (String(this.payload?.categoriesId?.[0])) {
      case '1': // HOTEL
          if (this.orderPriceby == "priceLow") {
              this.orderPriceLow();
          }
          if (this.orderPriceby == "priceHigh") {
              this.orderPriceHigh();
          }
          this.getPagesNew(this._actualItinerary?.currency ? this._actualItinerary?.currency : null, null, 'filter-result');
          this.searchFilter();
          this.resultTotal = this.results.length;
          break;
      case '2': // RENT-A-CAR
          if (this.orderPriceby == "priceLow") {
            this.orderPriceLow();
          }
          if (this.orderPriceby == "priceHigh") {
            this.orderPriceHigh();
          }

          if (this.selectedFilters.length > 0) {
            let results = [];
            this.selectedFilters.forEach((filter_) => {
              results = this.filterArray(this.results, [filter_.type], [filter_.value]);
              // console.log('filter array', results);
              if (results != undefined) {
                this.results = results;
              }
            });
          }
          this.getPagesNew(this._actualItinerary?.currency ? this._actualItinerary?.currency : null, null, 'filter-result');
          this.searchFilter();
          this._filtersRentacar.emit(this.filtersRentacar);
          break;
      case '6': // Experiencia
          if (this.orderPriceby == "priceLow") {
          this.orderPriceLow();
          }
          if (this.orderPriceby == "priceHigh") {
              this.orderPriceHigh();
          }
          this.getPagesNew(this._actualItinerary?.currency ? this._actualItinerary?.currency : null, null, 'filter-result');
          this.searchFilter();
        break;
      case '8': // TRANSPORTS
        if (this.orderPriceby == "priceLow") {
          this.orderPriceLow();
          }
          if (this.orderPriceby == "priceHigh") {
              this.orderPriceHigh();
          }
          this.getPagesNew(this._actualItinerary?.currency ? this._actualItinerary?.currency : null, null, 'filter-result');
          this.searchFilter();
        break;
       case '9': // Tickets
          if (this.orderPriceby == "priceLow") {
          this.orderPriceLow();
          }
          if (this.orderPriceby == "priceHigh") {
              this.orderPriceHigh();
          }
          this.getPagesNew(this._actualItinerary?.currency ? this._actualItinerary?.currency : null, null, 'filter-result');
          this.searchFilter();
        break;
      case '10': // ASISTENCIA
        if (this.orderPriceby == "priceLow") {
          this.orderPriceLow();
          }
          if (this.orderPriceby == "priceHigh") {
              this.orderPriceHigh();
          }
          this.getPagesNew(this._actualItinerary?.currency ? this._actualItinerary?.currency : null, null, 'filter-result');
          this.searchFilter();
        break;
      case '5': // FLIGHTS
        if (this.orderPriceby == "priceLow") {
          this.orderPriceLow();
        }
        if (this.orderPriceby == "priceHigh") {
          this.orderPriceHigh();
        }
        this.getPagesNew(this._actualItinerary?.currency ? this._actualItinerary?.currency : null, null, 'filter-result');
        this.searchFilter();
        this.resultTotal = this.results.length;
        break;
      default:
          break;
  }

  this.arrayOut.emit(this.resultPaged);
}


/**
 * Método para limpiar los filtros aplicados y restaurar los resultados iniciales.
 *
 * Este método elimina los filtros activos, resetea los valores y vuelve a cargar los resultados originales.
 *
 * @results -> Arreglo con los resultados visibles.
 * @selectedStars -> Filtros de estrellas seleccionados para hoteles.
 * @text -> Texto del filtro de búsqueda.
 */
clearFilter() {
    this.results = [];
    this.results = this.resultsAux;
    this.resetFilter();
    this.searchFilter();
    this.searchPriceLowAndHigh();
    this.filterResults();
    this.selectedStars = -1;
    this.filter = [];
    this.selectedAmenityKeywords = [];
    this.selectedRateTypes = [];
    this.selectedBoardKeys = [];
    this.luggageSelected = [];//Rent-a-car Maletas
    this.acrissSelected = [];
    this.text = '';
    this.resetPriceSlider();

      this.checkboxes.forEach((checkbox: ElementRef<HTMLInputElement>) => {
    checkbox.nativeElement.checked = false;
  });

  // this.currencyChecked(this._actualItinerary.currency);
}

/**
 * Ordena la lista de resultados en función del precio más bajo.
 *
 * Dependiendo del tipo de categoría (HOTEL, RENT-A-CAR, TOUR), aplica un algoritmo específico para ordenar:
 * - Para HOTELS: selecciona el precio más bajo por cada habitación disponible.
 * - Para RENT-A-CAR: ordena según el precio neto del alquiler del auto.
 * - Para TOURS: ordena según el precio mínimo disponible para las opciones de tour.
 *
 * @categoryId -> Identificador de la categoría para determinar el tipo de entidad a ordenar.
 * @results -> Arreglo de resultados que se ordenan según el criterio de la categoría.
 */
orderPriceLow() {
  switch (this.categoryId) {
    case 1: // HOTEL
      this.results.sort((a, b) => {
        const aRooms = a?.additionalInfo?.rooms ?? [];
        const bRooms = b?.additionalInfo?.rooms ?? [];

        const aMinPrice = aRooms.length
          ? Math.min.apply(null, aRooms.map(room => room.room.optionNightsNetTotalProf))
          : Infinity;
        const bMinPrice = bRooms.length
          ? Math.min.apply(null, bRooms.map(room => room.room.optionNightsNetTotalProf))
          : Infinity;

        return aMinPrice - bMinPrice;
      });
      break;
    case 2: // RENT-A-CAR
      this.results.sort((a, b) => a.additionalInfo.carRental.netPriceProf - b.additionalInfo.carRental.netPriceProf);
      break;
    case 5: // FLIGHTS
      this.results.sort((a, b) => getFlightPrice(a) - getFlightPrice(b));
      break;
    case 6: // TOUR
        this.results.sort((a, b) => {
          const getMinValidPrice = (result) => {
            const prices = result.additionalInfo?.tours?.options
              ?.map(option => option.totalPrice)
              .filter(price => price != null && !isNaN(price) && isFinite(price))
              .map(price => Number(price));

            return prices && prices.length > 0 ? Math.min(...prices) : Infinity;
          };


          const minPriceA = getMinValidPrice(a);
          const minPriceB = getMinValidPrice(b);

          return minPriceA - minPriceB;
        });
      break;

    case 8: // TRANSPORTS

    this.results.forEach(result => {
    result.vehicles.sort((a, b) => a.totalPriceProf - b.totalPriceProf);
    });

    this.results.sort((a, b) => {
      const minA = Math.min.apply(null, a.vehicles.map(v => v.totalPriceProf));
      const minB = Math.min.apply(null, b.vehicles.map(v => v.totalPriceProf));
      return minA - minB;
    });
    break;
    case 9: // tickets
        this.results.sort((a, b) => {
          const getMinValidPrice = (result) => {
            const prices = result.additionalInfo?.tours?.options
              ?.map(option => option.totalPrice)
              .filter(price => price != null && !isNaN(price) && isFinite(price))
              .map(price => Number(price));
            return prices && prices.length > 0 ? Math.min(...prices) : Infinity;
          };

          const minPriceA = getMinValidPrice(a);
          const minPriceB = getMinValidPrice(b);

          return minPriceA - minPriceB;
        });
      break;
    case 10: // ASISTENCIA
  console.log(this.results);

  // ✅ Primero: Ordenar los planes dentro de cada insurance
  this.results.forEach(result => {
    if (result.insurances && Array.isArray(result.insurances)) {
      result.insurances.sort((a, b) => {
        const priceA = a?.plan?.totalPriceProf ?? Infinity;
        const priceB = b?.plan?.totalPriceProf ?? Infinity;
        return Number(priceA) - Number(priceB);
      });
    }
  });

  // ✅ Segundo: Ordenar los results por el plan más barato de cada insurance
  this.results.sort((a, b) => {
    const getMinValidPrice = (result) => {
      const prices = result.insurances
        ?.map(option => option?.plan?.totalPriceProf)
        .filter(price => price != null && !isNaN(price) && isFinite(price))
        .map(price => Number(price));

      return prices && prices.length > 0 ? Math.min(...prices) : Infinity;
    };

    const minPriceA = getMinValidPrice(a);
    const minPriceB = getMinValidPrice(b);

    return minPriceA - minPriceB;
  });

  break;
    default:
      break;
  }
  this.page = 1;
}

/**
 * Ordena la lista de resultados en función del precio más alto.
 *
 * Dependiendo del tipo de categoría (HOTEL, RENT-A-CAR, TOUR), aplica un algoritmo específico para ordenar:
 * - Para HOTELS: selecciona el precio más alto por cada habitación disponible.
 * - Para RENT-A-CAR: invierte la lista ordenada por precio neto del alquiler del auto.
 * - Para TOURS: selecciona el precio máximo disponible para las opciones de tour.
 *
 * @payload.categoriesId[0] -> Identificador de la categoría para determinar el tipo de entidad a ordenar.
 * @results -> Arreglo de resultados que se ordenan según el criterio de la categoría.
 */
orderPriceHigh() {
  switch (String(this.payload?.categoriesId?.[0])) {
    case '1': // HOTEL
      this.results.sort((a, b) => {
        const aRooms = a?.additionalInfo?.rooms ?? [];
        const bRooms = b?.additionalInfo?.rooms ?? [];

        const aMinPrice = aRooms.length
          ? Math.min.apply(null, aRooms.map(room => room.room.optionNightsNetTotalProf))
          : Infinity;
        const bMinPrice = bRooms.length
          ? Math.min.apply(null, bRooms.map(room => room.room.optionNightsNetTotalProf))
          : Infinity;

        return bMinPrice - aMinPrice;
      });
      break;
    case '2': // RENT-A-CAR
      this.results.sort((a, b) => b.additionalInfo.carRental.netPriceProf - a.additionalInfo.carRental.netPriceProf);
      break;
    case '5': // FLIGHTS
      this.results.sort((a, b) => getFlightPrice(b) - getFlightPrice(a));
      break;
    case '6': // TOUR
      this.results.sort((a, b) => {
        const getMinValidPrice = (result) => {
          const prices = result.additionalInfo?.tours?.options
            ?.map(option => option.totalPrice)
            .filter(price => price != null && !isNaN(price) && isFinite(price))
            .map(price => Number(price));

          return prices && prices.length > 0 ? Math.min(...prices) : -Infinity;
        };

        const minPriceA = getMinValidPrice(a);
        const minPriceB = getMinValidPrice(b);

        return minPriceB - minPriceA;
      });
      break;
    case '8': // TRANSPORTS
        this.results.forEach(result => {
          result.vehicles.sort((a, b) => a.totalPriceProf - b.totalPriceProf);
        });
        this.results.sort((a, b) => {
          const minA = Math.min.apply(null, a.vehicles.map(option => option.totalPriceProf));
          const minB = Math.min.apply(null, b.vehicles.map(option => option.totalPriceProf));
          return minB - minA;
        });
        break;
    case '9': // Tickets
      this.results.sort((a, b) => {
        const getMinValidPrice = (result) => {
          const prices = result.additionalInfo?.tours?.options
            ?.map(option => option.totalPrice)
            .filter(price => price != null && !isNaN(price) && isFinite(price))
            .map(price => Number(price));
          return prices && prices.length > 0 ? Math.min(...prices) : -Infinity;
        };

        const minPriceA = getMinValidPrice(a);
        const minPriceB = getMinValidPrice(b);

        return minPriceB - minPriceA;
      });
      break;
    case '10':
      this.results.forEach(result => {
        if (result.insurances && Array.isArray(result.insurances)) {
          result.insurances.sort((a, b) => {
            const priceA = a?.plan?.totalPriceProf ?? Infinity;
            const priceB = b?.plan?.totalPriceProf ?? Infinity;
            return Number(priceA) - Number(priceB);
          });
        }
      });

      this.results.sort((a, b) => {
        const getMinValidPrice = (result) => {
          const prices = result.insurances
            ?.map(option => option?.plan?.totalPriceProf)
            .filter(price => price != null && !isNaN(price) && isFinite(price))
            .map(price => Number(price));

          return prices && prices.length > 0 ? Math.min(...prices) : -Infinity;
        };

        const minPriceA = getMinValidPrice(a);
        const minPriceB = getMinValidPrice(b);

        return minPriceB - minPriceA;
      });
      break;
    default:
      break;
  }
  this.page = 1;
}


searchPriceLowReload(): void {
  this.searchPriceLowAndHigh();
  this.orderPriceLow();
}
 /**
 * @method searchPriceLowAndHigh
 * @description Searches for the lowest and highest prices within the results based on category.
 * Populates `filterLowPrice` and `filterHighPrice` with the respective values.
 * Updates `optionsSliderPrice` to set the slider range between the minimum and maximum prices.
 */
searchPriceLowAndHigh() {
  let resulPriceLow = [];
  let resulPriceHigh = [];
  if (this.results.length > 0) {
      switch (String(this.payload?.categoriesId?.[0])) {
          case '5': { // FLIGHTS
              const flightPrices = this.results
                  .map((flight: any) => getFlightPrice(flight))
                  .filter((price: number) => price != null && !isNaN(price) && price > 0);
              this.filterLowPrice = flightPrices.length ? Math.min(...flightPrices) : 0;
              this.filterHighPrice = flightPrices.length ? Math.max(...flightPrices) : 0;
              break;
          }
          case '1': // HOTEL
              resulPriceLow = this.results.map((data: any) => {
                  if (data.additionalInfo) {
                      const lowestPrice = Math.min.apply(
                          null,
                          data.additionalInfo.rooms.map((room: any) =>
                              room?.room?.optionNightsNetTotalProf || Infinity
                          )
                      );
                      return lowestPrice !== Infinity ? lowestPrice : undefined;
                  }
                  return undefined;
              });

              const flattenedPrices = resulPriceLow.reduce((acc: any[], val: any[]) => acc.concat(val), []);
              const validPrices = flattenedPrices.filter((price: any) => price !== undefined);
              const minPrice = Math.min(...validPrices);
              resulPriceLow = [minPrice];

              resulPriceHigh = this.results.map((data: any) => {
                  if (data && data.additionalInfo) {
                      const highestPrice = Math.max.apply(
                          null,
                          data.additionalInfo.rooms.map((room: any) =>
                              room?.room?.optionNightsNetTotalProf || -Infinity
                          )
                      );
                      return highestPrice !== -Infinity ? highestPrice : undefined;
                  }
                  return undefined;
              });

              const flattenedPricesHigh = resulPriceHigh.reduce((acc: any[], val: any[]) => acc.concat(val), []);
              const validHighPrices = flattenedPricesHigh.filter((price: any) => price !== undefined);

              const maxPrice = Math.max(...validHighPrices);
              resulPriceHigh = [maxPrice];

              this.filterLowPrice = Math.min.apply(null, resulPriceLow); // ✅ Sin Math.floor
              this.filterHighPrice = Math.max.apply(null, resulPriceHigh); // ✅ Sin Math.floor

              break;

          case '2': // RENT-A-CAR
              this.filterLowPrice = this.results.map(el => el.additionalInfo.carRental.netPriceProf)
                  .reduce((prevEl, el) => Math.min(prevEl, el));
              this.filterHighPrice = this.results.map(el => el.additionalInfo.carRental.netPriceProf)
                  .reduce((prevEl, el) => Math.max(prevEl, el));
              break;

          case '6': // TOURS

             const validPricesTour = this.results
                  .map(el => el.additionalInfo?.tours?.options[0]?.totalPrice)
                  .filter(price => price != null && !isNaN(price))
                  .map(price => Number(price));

                this.filterLowPrice = validPricesTour.length > 0 ? Math.min(...validPricesTour) : 0;
                this.filterHighPrice = validPricesTour.length > 0 ? Math.max(...validPricesTour) : 0;
              break;

          case '8':
              this.filterLowPrice = this.results.map(el => el.vehicles[0]?.totalPriceProf)
                  .reduce((prevEl, el) => Math.min(prevEl, el));
              this.filterHighPrice = this.results.map(el => el.vehicles[0]?.totalPriceProf)
                  .reduce((prevEl, el) => Math.max(prevEl, el));
              break;
          case '10':
           this.filterLowPrice = this.results.map(el => el.insurances[0]?.plan?.totalPriceProf)
                  .reduce((prevEl, el) => Math.min(prevEl, el));
              this.filterHighPrice = this.results.map(el => el.insurances[0]?.plan?.totalPriceProf)
                  .reduce((prevEl, el) => Math.max(prevEl, el));
              break;

          default:
              break;
      }

      this.optionsSliderPrice.floor = this.filterLowPrice;
      this.optionsSliderPrice.ceil = this.filterHighPrice;
  }
}

/**
* @method setCarGroup
* @description Filters the car rental results to remove duplicates based on the title property.
* Ensures that only unique entries remain in the results.
*/
setCarGroup() {
  this.results = this.results.filter((data, index, j) =>
      index === j.findIndex(t => t.title == data.title && t.providerName == data.providerName)
  );
}

/**
 * Método para obtener y filtrar resultados basados en la moneda seleccionada.
 *
 * Este método permite filtrar resultados según la moneda proporcionada y manejar
 * los casos en los que no hay resultados disponibles o los datos deben ser recargados.
 * Además, controla la visualización de mensajes y redirecciones según el contexto.
 *
 * @param currency (opcional) - Moneda utilizada para filtrar los resultados.
 * Si no se proporciona, se utiliza la moneda del itinerario activo.
 * @param reload (opcional) - Indica si los datos deben recargarse tras la ejecución.
 *
 * Variables:
 * - `currencyFilterEmpty`: Booleano que determina si el filtro de moneda no arrojó resultados.
 * - `currencyFilterNewResultEmpty`: Booleano que identifica si no hay resultados para la moneda actual.
 *
 * Lógica:
 * 1. Se establece la moneda a filtrar si no se especifica.
 * 2. Se filtran los resultados según la moneda.
 * 3. Se muestran mensajes y modales si no hay resultados para la moneda seleccionada.
 * 4. Se asignan resultados a `resultPaged` según el origen de la búsqueda.
 * 5. Se manejan redirecciones y validaciones de categoría según el valor de `reload`.
 */
  getPagesNew(currency?: any, reload?: boolean, type?: string) {

    // this.currencyChecked(currency, reload);

    if (this.results.length > 0) {
      const searchID =
        this.results["searchId"] === null || this.results["searchId"] === undefined
          ? this.results[0]["searchId"]
          : this.results["searchId"];
      if(this.origin === 'HOTELS') {
        // if(this.first_charge === false) {
          this.resultPaged = [this.results];

        // } else {
          // this.resultPaged = this.results;
        //   this.first_charge = false;
        // }
        this._items = this.results.length;
      } else {
        this.resultPaged = this.results;
        //  this._colocarSearchIdEnlosHoteles(this.results);
        this._items = this.results.length;
      }
      if (this.index == 0) {
        this._emitLoading(false);
      }
      if(reload === true) {
        this.handleCategoryValidation(); // Validación según la categoría seleccionada
      }
      this._total = this.resultPaged.length;
      if(reload === false) {
        this._setArrivalAndDepartureDate(this.resultPaged, this.results.form);
        this.serviceItinerary.sendMessageSubscriptorItemSelected(this.results.destination, this.categoryName);
      }

    }
    else {
      // this.currencyChecked(currency, null, 'noResult');
      }
  }

  noResultsFilter(): void {
    this.hasExecutedElse = true;
    const initialState: ModalOptions = {
      initialState: {
        data: 'No se encontraron datos, para los parámetros suministrados'
      }
    }
    const modalOptions = Object.assign({}, initialState, this.config);
    this.bsModalRef = this.modalService.show(MaterialModalAlertComponent,  modalOptions);

    this.clearFilter();
  }

  alertEmptyResultOrFilter(currency): void {
        let textAlert = '';

        if(currency) {
                      if(this._actualItinerary.items.length > 0) {
                          textAlert = 'No hay resultados por la moneda establecida en el file. Será redireccionado al detalle de la reserva para continuar con su reserva';
                        } else if(this._actualItinerary.items.length === 0) {
                          textAlert = 'No hay resultados por la moneda establecida en el file. Será redireccionado al inicio para poder realizar una nueva búsqueda';
                        }
                      }
        if(currency === null) {
          if(this._actualItinerary.items.length === 0) {
            textAlert = 'No hay resultados. Será redireccionado al inicio';
          }
        }


             const initialState: ModalOptions = {
               initialState: {
                 data: textAlert
               }
             }
             const modalOptions = Object.assign({}, initialState, this.config);
             this.bsModalRef = this.modalService.show(MaterialModalAlertComponent,  modalOptions);

             this.confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
               if(result) {
                 if(this._actualItinerary.items.length > 0) {
                   this.route.navigate(['/summary']);
                 } else if(this._actualItinerary.items.length === 0) {
                   this.route.navigate(['/home']);
                 }
               }
             });

        }

  /**
 * Capitaliza la primera letra de una cadena de texto.
 *
 * @param str - Cadena de texto a procesar.
 * @returns Cadena con la primera letra en mayúscula.
 */
capitalizeFirstLetter(str: any) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Alterna el estado de colapso del contenido.
 */
toggleCollapse() {
  this.contentCollapsed = !this.contentCollapsed;
}

/**
 * Emite un evento con el payload proporcionado.
 *
 * @param payload - Datos a emitir.
 */
_onPayload(payload: any) {
  this.payload_.emit(payload);
}

/**
 * Emite un evento con los resultados proporcionados.
 *
 * @param results - Resultados a emitir.
 */
_onResults(results: any) {
  this.results_.emit(results);
}

/**
 * Emite un evento para cambiar el estado de carga.
 *
 * @param isLoading - Estado del proceso de carga.
 */
_onLoading(isLoading: boolean) {
  this.isLoading.emit(isLoading);
}

/**
 * Emite un evento con el origen proporcionado.
 *
 * @param origin - Origen a emitir.
 */
_onOrigin(origin: any) {
  this._origin.emit(origin);
}

/**
 * Cambia la página actual y desplaza la ventana al inicio.
 *
 * @param page - Número de página al que se debe cambiar.
 */
onPageChange(page: number) {
  this.page = page;
  window.scrollTo(0, 0);
}

/**
 * Abre un modal con información del producto.
 *
 * @param result - Datos del producto para mostrar en el modal.
 */
openModal(result: any) {
  // Pausar la recarga en segundo plano mientras el modal de producto está abierto — igual que
  // ya hace openFormSearch() para el modal de búsqueda del navbar (openModalResearch), acá con
  // noLoadingForModal/reloadAgainSubject para no competir con la interacción del usuario.
  this.noLoadingForModal = true;
  this.reloadAgain = false;
  this.reloadAgainSubject.next(false);

  var dialogRef = this.dialog.open(ModalsComponent, {
     disableClose: true,
      width: '80%',
      maxHeight: '90vh', // Establece una altura máxima
    data: {
      modalRoomRef: this.modalRef,
      product: result,
      productQty: this.payload.qtyProduct,
      form: this.results.form,
      origin: "HOTELS",
      arrayResults: this.results,
    },
  });

  dialogRef.afterClosed().subscribe((result) => {
    // Acción a realizar después de cerrar el modal
    this.noLoadingForModal = false;
    if (!this.finishReload) {
      this.reloadAgain = true;
      this.reloadAgainSubject.next(true);
      this.scheduleNextCheck();
    }
  });
}


  moveMapToCoordinates(hotelSelected) {
    // console.log(hotelSelected);

    // let icon = `<svg width="200" height="200" xmlns="http://www.w3.org/2000/svg">
    // <image href="assets/logo.png" height="200" width="200"/>
    // </svg>`;

    // //se inicializa el mapa con zoom 4
    // let geocoder: any;
    // let mapa: any;
    // let infowindow = null;
    // let currentInfoWindows = null;
    // let mapOptions = {
    // center: new google.maps.LatLng(28.3256749, -81.51555309999999),
    // zoom: 4,
    // mapTypeId: google.maps.MapTypeId.ROADMAP,
    // zoomControl: true,
    // };

    // mapa = new google.maps.Map(this.gmapElement.nativeElement, mapOptions);
    // // const resultados = await this.resultPaged;
    // const resultados = this.results;


    // for (let i = 0; i < resultados.length; i++) {
    //   const item = hotelSelected;
    //   const data = {
    //   image: item.additionalInfo.images.length > 0 ? item.additionalInfo.images[0].image : "",
    //   title: item.title ? item.title : "",
    //   rooms: item.additionalInfo.rooms ? item.additionalInfo.rooms : null,
    //   netPriceProf: item.additionalInfo.rooms ? item.additionalInfo.rooms[0].netPriceProf : "",
    //   netPrice: item.additionalInfo.rooms ? item.additionalInfo.rooms[0].netPrice : "",
    //   roomPackageRefPriceProf: item.additionalInfo.roomsPackage ? item.additionalInfo.roomsPackage[0].netPriceProf : "",
    //   optionNightsNetTotal: item.additionalInfo.rooms ? item.additionalInfo.rooms[0].optionNightsNetTotal : "",
    // eslint-disable-next-line
    //   optionNightsNetTotalProf: item.additionalInfo.rooms ? item.additionalInfo.rooms[0].optionNightsNetTotalProf : "",
    //   blickoins: item.additionalInfo.rooms ? item.additionalInfo.rooms[0].blickoins : "",
    //   creditBlickoins: item.additionalInfo.rooms ? item.additionalInfo.rooms[0].creditBlickoins : "",
    //   percentage: item.additionalInfo.rooms ? item.additionalInfo.rooms[0].percentage : "",
    //   latlng: item.coordinates ? item.coordinates : "",

    // };


    //   geocoder = new google.maps.Geocoder();
    //   const title = item.title;
    //   let addIcon = "favorite_border";
    //   // (click)="openModal(${item})"
    //   const infowindow = new google.maps.InfoWindow({
    //       content: `
    //       <div id="hotel-result-component" class="d-flex justify-content-between" style="width: 30rem;height: 12em; background: white !important;">
    //         <div class="d-flex container-img" style="width:40% !important; overflow: hidden">
    //           <img class="img-responsive" style="width: 80%;height: 100% !important; object-fit: contain" src="${
    //           data?.image
    //           }" onerror="if (this.src != 'assets/img/app/hotel_default.png') this.src = 'assets/img/app/hotel_default.png';">
    //         </div>
    //         <div class="d-flex flex-column container-detalles p-3" style="width: 60% !important;">
    //           <div class="d-flex justify-content-end">
    //             <span class="material-icons add-icon add_circle" id="fav${i}"></span>
    //             <span class="material-icons add-icon cancel" id="close"></span>

    //         </div>
    //          <div class="d-flex" style="max-height: 50px; overflow: hidden;margin-top: .7em;">
    //           <p class="m-0"
    //             style="font-size: 18px; letter-spacing: 0px; line-height: 1; color: #272727; font-weight: 600; font-family: "Poppins", sans-serif;"
    //             title="${data.title}">${data.title}</p>
    //         </div>
    //         <div class="d-flex flex-column">
    //           <div class="d-flex">
    //             <p class="m-0" style="font-size: 20px; letter-spacing: -1px; line-height: 1; color: #272727; font-weight: 600; font-family: "Poppins", sans-serif;">USD <span>${
    //               data?.netPriceProf ? data.netPriceProf : ""
    //             }</span></p>
    //         </div>
    //         <div>
    //          <p style="font-size: 10px; font-weight: 500;margin-bottom:0;">Estadia total</p>
    //         </div>

    //         <!-- <div class="d-flex flex-column">
    //           <p class="m-0" style="font-size:10px; color: red;  font-weight: bold;">P. Costo:&nbsp;${data.netPrice}</p>
    //           <p class="m-0" style="font-size: 13px !important; color: #272727; font-weight: 600; font-family: "Poppins", sans-serif;">P/Night</p>
    //         </div> -->
    //         </div>
    //           <div class="d-flex justify-content-between margin-bottom: 5px;">
    //           <div class="d-flex align-items-middle">
    //             <i class="icon icon-medal mr-1"></i>
    //             <span class="font-point d-flex align-items-center">
    //               ${data.blickoins ? data.blickoins : "X"}&nbsp;Bks
    //             </span>
    //             <span class="font-point d-flex align-items-center">
    //               <p class="p-night m-0 pl-2">$&nbsp;${data.blickoins ? data.creditBlickoins : "X"}</p>
    //               </span>
    //           </div>
    //           <div class="d-flex flex-row">
    //           <!--  <span class="font-desc" style=" font-family: 'Lato', sans-serif  !important;">15</span>
    //             <i class="icon icon-descuento"></i> -->
    //           </div>
    //           </div>
    //         </div>
    //       </div>

    //   `,
    //   });

    //   const latlng = {
    //   lat: parseFloat(data.latlng.latitude),
    //   lng: parseFloat(data.latlng.longitude),
    //   };

    //   // setTimeout( () => {
    //   geocoder.geocode({ location: latlng }).then((response) => {
    //     if (response.results[0]) {
    //     const marker = new google.maps.Marker({
    //       position: latlng,
    //       map: mapa,
    //       title: title,
    //       draggable: false,
    //       label: {
    //         text: "USD " + data.netPriceProf.toString(),
    //         className: "tooltip-one",
    //       },
    //       icon: " ",
    //   });

    //   this.markerArray.push(marker);

    //   if (hotelSelected) {
    //     // Cerrar la ventana de información si se hace clic afuera del modal
    //     const closeInfoWindowOnOutsideClick = (event: any) => {
    //       const infowindowContent = document.querySelector('.gm-style-iw') as HTMLElement;
    //       if (infowindowContent && !infowindowContent.contains(event.target)) {
    //         infowindow.close();
    //         document.removeEventListener('click', closeInfoWindowOnOutsideClick);
    //       }
    //     };

    //     // Agregar evento de clic al documento para cerrar la ventana de información al hacer clic afuera
    //     document.addEventListener('click', closeInfoWindowOnOutsideClick);

    //     if (currentInfoWindows) {
    //       currentInfoWindows.close();

    //     }

    //     infowindow.open(mapa, marker);
    //     currentInfoWindows = infowindow;
    //   }


    //   marker.addListener('click', () =>{

    //     if(currentInfoWindows){
    //     currentInfoWindows.close()
    //     }

    //     infowindow.open(mapa, marker);
    //     currentInfoWindows = infowindow;
    //   });

    //   google.maps.event.addListener(infowindow, "domready", () => {
    //     const el = document.getElementById("fav" + i);
    //     const close = document.getElementById("close");
    //     el.addEventListener("click", (event) =>{
    //       this.openModal(item);
    //   })

    //   close.addEventListener('click', (event) =>{
    //     infowindow.close();
    //   })

    //   });

    //   google.maps.event.trigger(mapa, "resize");
    //     mapa.panTo(marker.getPosition());
    //     mapa.setZoom(10);
    //     } else {
    //     console.log("No se obtuvo la ubicacion del mapa: " + status);
    //     }
    //     });
    //   // }, 2000 * i);

    //          // Abre la ventana de información cuando se carga hotelSelected


    //   }
    //   mapa.set("parent", this);



}

ngAfterViewInit() {

  setTimeout(() => this.customizeSlider(), 100);
  // this.applyStarFilter(-1);

   this.documentKeydownListener = this.renderer.listen(
    'document',
    'keydown.escape',
    (event: KeyboardEvent) => {
      if (this.showOrder) {
        this.showOrder = false;
        event.preventDefault();
      }
    }
  );
}

private customizeSlider() {
  // Verificar que headerStyle y card_line existan
  if (!this.headerStyle?.card_line) {
    console.warn('headerStyle.card_line no está definido');
    return;
  }

// Verificamos que el slider esté completamente renderizado
  if (!this.slider) {
    console.error('Slider no está disponible');
    return;
  }

//   setTimeout(() => {
// console.log(this.slider)
    // 1. Handles (deslizadores) - Acceso a través de las propiedades del componente
    const sliderComponent = this.slider as any; // Cast temporal para acceder a propiedades internas
    if (sliderComponent.minHandleElement && sliderComponent.maxHandleElement) {
      const minHandle = sliderComponent.minHandleElement.elemRef.nativeElement;
      const maxHandle = sliderComponent.maxHandleElement.elemRef.nativeElement;

      this.renderer.setStyle(minHandle, 'background-color', this.headerStyle.card_line);
      this.renderer.setStyle(minHandle, 'top', '-14.5px');

      this.renderer.setStyle(maxHandle, 'background-color', this.headerStyle.card_line);
      this.renderer.setStyle(maxHandle, 'top', '-14.5px');
    }

    // 2. Barra de selección
    if (sliderComponent.selectionBarElement) {
      const selectionBar = sliderComponent.selectionBarElement.elemRef.nativeElement.firstChild;
      this.renderer.setStyle(selectionBar, 'background', this.headerStyle.card_line);
      this.renderer.setStyle(selectionBar, 'height', '4px');
    }

    // 3. Texto (burbujas)
    if (sliderComponent.minHandleLabelElement && sliderComponent.maxHandleLabelElement) {
      const minLabel = sliderComponent.minHandleLabelElement.elemRef.nativeElement;
      const maxLabel = sliderComponent.maxHandleLabelElement.elemRef.nativeElement;

      this.renderer.setStyle(minLabel, 'font-family', '"Roboto"');
      this.renderer.setStyle(minLabel, 'font-size', '12px');
      this.renderer.setStyle(minLabel, 'font-wieght', '500');
      this.renderer.setStyle(minLabel, 'color', 'black');

      this.renderer.setStyle(maxLabel, 'font-family', '"Roboto"');
      this.renderer.setStyle(maxLabel, 'font-size', '12px');
      this.renderer.setStyle(maxLabel, 'font-wieght', '500');
      this.renderer.setStyle(maxLabel, 'color', 'black');
    }
  // }, 100);
}


  _getCitys(param: any) {
 /*   this._restService.doGet("api", "/searchlocations/" + param).subscribe(
      (res) => {
        for (let index = 0; index < res["Cities"].length; index++) {
          if (res["Cities"][index]["cityIataCode"] === param) {
            this.ori = res["Cities"][index]["cityName"];
          }
        }
      },
      (Error) => {
        console.log("Error", Error);
      }
    );*/
  }

/**
 * Emite un evento para actualizar la vista del mapa.
 *
 * @param event - Valor booleano que indica el estado de la vista del mapa.
 */
_emitViewMap(event: boolean) {
  this.emitViewMap.emit(event);


}

/**
 * Emite un evento para realizar una nueva búsqueda.
 *
 * @param event - Evento que desencadena la acción de búsqueda.
 */
_emitReSearch(event: Event) {
  this.emitReSearch.emit(event);
}

researchPaxList(payload: any, reload: boolean, refresh?: boolean): void {

  // Resetear flags
  this.noLoadingForModal = false;
  this.pausedByMouseEnter = false;
  this.openModalResearch = false;
  this.finishReload = false;
  this.lastResultsCount = null;

  if (reload === false) {
    this._onPayload(payload);
    this.payload = Array.isArray(payload) ? payload[0] : payload;
    this._emitLoading(true);
  }

  if (this.modalSearch && reload === false) {
    this.modalSearch._initLoadData(payload);
  }

  // Ejecutar búsqueda de emergencia
  this.emergencySearch(payload[0], true);


}

private emergencySearch(payload: any, reload: boolean = true): void {

  this.arrivalDate = payload?.arrivalDate;
  this.departureDate = payload?.departureDate;
  const formFromStorage = JSON.parse(localStorage.getItem('form'));
  if (formFromStorage) {
    this.cityNameForm = formFromStorage;
  }

  this._restService.doPost("app", "search", payload).subscribe({
    next: (response: any) => {
        if (response &&
            response.results &&
            Array.isArray(response.results) &&
            response.results.length === 0) {
          this.handleNoResults();
          return;
        }

       const payloadActually = JSON.parse(localStorage.getItem('payload'));

      if (this.isResponseValid(response, payloadActually)) {
        this.lastPollFailed = false; // último poll exitoso: el ciclo puede reactivarse normalmente
        this.lastResponse = response;
        this.shouldUpdateUI(response, reload, reload);
      } else {
        console.warn('⚠️ Respuesta obsoleta ignorada en executeSearchForceNew');
        return;
      }

      // REACTIVAR EL CICLO DE RECARGA
      if (reload) {
        // Asegurar flags para permitir el ciclo
        this.finishReload = false;
        this.reloadAgain = true;
        // Programar siguiente verificación
        this.scheduleNextCheck();
        // Opcional: forzar el subject si es necesario
        this.reloadAgainSubject.next(true);
      }
    },
    error: (error) => {
      console.error('❌ Error en búsqueda de emergencia:', error);
      this.lastPollFailed = true;
    }
  });
}
// /**
//  * Realiza una búsqueda de itinerarios con los parámetros proporcionados.
//  * La búsqueda puede ser recargada o refrescada según los parámetros opcionales `reload` y `refresh`.
//  *
//  * @param payload - Datos para la búsqueda.
//  * @param reload - Determina si se debe recargar la búsqueda.
//  * @param refresh - Determina si se debe refrescar la búsqueda.
//  */
// reloadSearch(payload: any, reload?: boolean, refresh?: boolean): void {
//   // console.log("Iniciando búsqueda con payload:", payload);
//   if(!this.noLoadingForModal) {

//     this.arrivalDate = payload.arrivalDate;
//     this.departureDate = payload.departureDate;

//    if (reload === true) {
//       this.resultReload = true;
//     }

//     this._restService.doPost("app", "search", payload).subscribe({
//       next: (response: any) => {
//         if(response.results.length === 0){
//           this.handleNoResults();
//         }

//         if(!this.noLoadingForModal && !this.pausedByMouseEnter && !this.openModalResearch && this.page === 1) {

//           if (response && response.results) {

//             // console.log(response.results.length)
//             const totalResult = {...response.results.length};
//             // console.log(totalResult)
//             this.totalResponse = totalResult;
//             // console.log(this.totalResponse)
//             this.results = response.results;



//             if (this.results.length > 0) {
//               this.filterResults();

//               if (reload) {
//                  if (refresh) {

//                       refresh = false;
//                       // this.subscribeReloadSearch();
//                     } else {
//                       if (this.cancelResearch(response.results.length)) {
//                           this.reloadAgain = false;
//                           this.finishReload = true;
//                           this.reloadAgainSubject.next(false);
//                           this.textBarCharge = 'Carga de resultados completada';
//                       } else {
//                         setTimeout(() => {

//                           this.reloadAgain = true;
//                           this.processSearchReload();
//                         }, 2500);
//                           // console.log("Me actualizo finalmente...");
//                     }

//                 }
//               this.resultsAux = [...this.results];
//               this.resultTotal = this.results.length;
//               this._emitLoading(false);
//               this.itineraryService.notifyModalClosed(false);
//               this.reloadSearching = false;
//               } else {
//                 this._emitLoading(false);
//                 this.itineraryService.notifyModalClosed(false);


//               }
//             } else {
//               this.handleNoResults();
//             }
//           } else {
//             if(this.results && this.results.length === 0) {
//               this.handleNoResults();
//             }
//           }
//         }

//         if(this.page > 1) {
//             this.reloadAgain = false;
//             this.finishReload = true;
//             this.reloadAgainSubject.next(false);
//             this.textBarCharge = 'Carga de resultados completada';
//             response = {};
//         }
//       },
//       error: (error: HttpErrorResponse) => {
//         console.error("Error en la búsqueda:", error);
//         this.isSearchRunning = false; // Marcar que la búsqueda terminó con error
//         if (!reload) {
//           this._emitLoading(false);
//           // this.showErrorModal();
//         } else {
//           // console.log("Error en recarga. Deteniendo proceso.");
//           this.reloadAgain = false;
//           this.reloadAgainSubject.next(false);
//         }
//       },
//       complete: () => {
//         this.isSearchRunning = false; // Marcar que la búsqueda terminó
//       },
//     });
//   }
// }

/**
 * Maneja el caso cuando no se encuentran resultados en la búsqueda.
 * Detiene el proceso y muestra un modal indicando que no se encontraron resultados.
 */
handleNoResults(): void {
  this.reloadAgain = false;
  this.finishReload = true;
  this.reloadAgainSubject.next(false);
  if (this.bsModalRef) {
    this.bsModalRef.hide();
  }

  const initialState: ModalOptions = {
    initialState: {
      message: '',
      confirmText: 'Cerrar',
      cancelText: 'Volver a intentar',
      showCancelButton: true,
      size: 'sm',
    },
  };
console.log('aca')
  const modalOptions = Object.assign({}, initialState, this.config);
  this.bsModalRef = this.modalService.show(NotFoundModalComponent, modalOptions);


  this.bsModalRef?.content?.subscribe((data: any) => {
    console.log(data);
    if(data) {
      console.log(data);
    }
  })
}

/**
 * Cancela la investigación si la longitud de los resultados no ha cambiado.
 *
 * @param responseLength - Longitud de los resultados obtenidos.
 * @returns `true` si no ha habido cambios, `false` en caso contrario.
 */
// cancelResearch(responseLength: number): boolean {
//   if (this.userService?.itineraryActive[0]?.currency) {
//     // if(this.OldResults === this.results.length) {
//       return true;
//     // } else {
//     //   return false;
//     // }
//   }

//   if (responseLength === this.results.length) {
//     return true;
//   }

//   return false;
// }

/**
 * Asocia un `searchId` a cada hotel en los resultados de la búsqueda.
 *
 * @param response - Respuesta de la búsqueda que contiene los hoteles.
 */
_colocarSearchIdEnlosHoteles(response: any) {
  response.results.forEach((item) => {
    item.searchId = response.searchId;
  });
}

/**
 * Establece la cantidad de niños para la búsqueda, activando la edición.
 *
 * @param qty - Cantidad de niños (no se utiliza en este método, pero se activa la edición).
 */
setQtyChildren(qty: any) {
  this.editable = true;
}

/**
 * Obtiene la cantidad de niños en la configuración de habitaciones de la búsqueda.
 *
 * @returns El número total de niños en la configuración de habitaciones.
 */
getQtyChildren() {
  let children = 0;
  const rooms = this.payload.others.hotels.roomConfiguration;
  rooms.forEach((room) => {
    children += room["children"].length;
  });
  return children;
}

/**
 * Establece la categoría de la búsqueda en función de la respuesta.
 *
 * @param searchResponse - La categoría recibida de la respuesta.
 */
setCategory(searchResponse: string) {
  switch (searchResponse) {
    case Procesed.TOURS:
      this.category = "Tours";
      break;
    case Procesed.HOTELS:
      this.category = "Hotels";
      break;
    case Procesed.TRANSPORTS:
      this.category = "Transports";
      break;
    case Procesed.INSURANCE:
      this.category = "Insurance";
      break;
  }
}


 /**
 * Emite el estado de carga.
 *
 * @param isLoading - Indica si la carga está en proceso (`true`) o ha terminado (`false`).
 */
_emitLoading(isLoading: boolean) {
  this.loaded = isLoading;
  this.isLoading.emit(isLoading);
}

/**
 * Establece las fechas de llegada y salida en los elementos de la respuesta.
 *
 * @param response - Respuesta que contiene los elementos a los que se les asignarán las fechas.
 * @param form - El formulario que contiene las fechas de llegada y salida.
 */
_setArrivalAndDepartureDate(response: any, form: any) {
  if (form !== undefined) {
    /*const arrival = form.value['arrivalDate'] !== undefined ? form.value['arrivalDate'] : form.value['firstArrivalDate'];
    const departure = form.value['arrivalDate'] !== undefined ? form.value['departureDate'] : form.value['secondArrivalDate'];
    response.forEach(item => {
      item.dateIni = moment(arrival.toString().split(',')[0]).format('YYYY-MM-DD');
      item.dateEnd = moment(departure.toString().split(',')[0]).format('YYYY-MM-DD');
    }); */
  }
  this.arrayOut.emit(this.resultPaged);
}

/**
 * Cierra o abre el colapso de un contenedor de información.
 *
 * @param close - Si es `true`, cierra el contenedor; si es `false`, lo abre.
 */
closeCollapse(close: boolean) {
  this.contentCollapsed = close;
}

/**
 * Devuelve la URL de la imagen asociada a un parque temático basado en su título.
 *
 * @param title - El título del parque temático.
 * @returns La URL de la imagen correspondiente al parque temático.
 */
getUrlImagePark(title: string) {
  let url = "assets/img/app/parque-tematico.jpg"; // default
  if (title !== undefined && title !== null) {
    title = title.toUpperCase();
    if (title.includes("UNIVERSAL")) {
      return (url = "assets/img/app/universal-ptheme.jpg");
    } else if (title.includes("DISNEY")) {
      return (url = "assets/img/app/walt-disney-world.jpg");
    } else if (title.includes("SEAWORLD")) {
      return (url = "assets/img/app/seaword-park-theme.jpg");
    } else if (title.includes("DISCOVERY COVE")) {
      return (url = "assets/img/app/pthemes-discovery-cove.png");
    } else if (title.includes("LEGOLAND")) {
      return (url = "assets/img/app/legoland-florida.jpg");
    } else if (title.includes("VOLCANO BAY")) {
      return (url = "assets/img/app/themeparks-volcanobay.png");
    } else if (title.includes("ISLAND")) {
      return (url = "assets/img/app/island-aventure-themeparks.png");
    }
    return url;
  }
}

/**
 * Abre el modal de comparación de elementos si se cumplen las condiciones.
 *
 * Verifica que la cantidad de elementos a comparar sea 2 o 3 antes de permitir la comparación.
 */
toCompare() {
  // if (this.itemToCompare.length < 2 || this.itemToCompare.length > 3) {
  // } else {
    //abrir modal
    this.modalCompare.show();
  // }
}

/**
 * Agrega o elimina un artículo de la lista de comparación.
 *
 * @param item - El artículo que se agregará o eliminará de la lista de comparación.
 */
addToCompare(item: any) {
  if (item.action == "add") {
    if (this.itemToCompare.length <= 3) {
      this.itemToCompare.push(item.item);
      if (this.itemToCompare.length == 3) {
        this.disbaledCompare = true;
      }
    }
  } else {
    let index = this.itemToCompare.findIndex((val) => val.title == item.item.title);
    this.itemToCompare.splice(index, 1);
    this.disbaledCompare = false;
  }
}


  modalCompareClose(event: any) {
    this.modalCompare.hide();
  }

  public changePage(event: any) {
    this._current = event;
  }

  public more() {
    this._currentGlobal++;
  }

  /**
 * Método para calcular la rentabilidad de diferentes tipos de servicios.
 *
 * Este método procesa la rentabilidad para varios tipos de servicios (hoteles, paquetes, tours, transportes, alquiler de coches, entre otros),
 * haciendo peticiones al backend para obtener los datos de rentabilidad y actualizando los objetos correspondientes.
 *
 * @param results - Arreglo de elementos (de tipo `any`) que contienen la información de los servicios.
 * @returns void
 *
 * El método maneja diferentes tipos de servicios:
 * - HOTELS: Actualiza la rentabilidad de habitaciones y paquetes de habitaciones.
 * - MULTIDESTINATION, TRANSPORTS: Actualiza la rentabilidad de transportes y vehículos.
 * - TOURS: Actualiza la rentabilidad de opciones de tours.
 * - RENT-A-CAR: Actualiza la rentabilidad de alquileres de coches.
 * - PACKAGES: Actualiza la rentabilidad de paquetes turísticos.
 * - DISNEY: Actualiza la rentabilidad de habitaciones en destinos Disney.
 * - PTHEMES: Actualiza la rentabilidad de opciones de parques temáticos.
 * - INSURANCE: Actualiza la rentabilidad de seguros.
 */
setProfitability(results: any) {

  results.forEach((item) => {
    switch (this.origin) {
      case "HOTELS":
        // Si es room
        if (item.additionalInfo.rooms) {
          this.serviceItinerary
            .getProfitability(item.additionalInfo.rooms[0].room.profility['netPrice'], item.categoryId, item.additionalInfo.rooms[0].provider.id)
            .subscribe((data: any) => {
              item.additionalInfo.rooms[0].netPriceProf = parseFloat(data["totalPrice"]);
              item.additionalInfo.rooms[0].percentage = parseFloat(data["percentage"]);
              item.additionalInfo.rooms[0].blickoins = parseFloat(data["blickoins"]);
              item.additionalInfo.rooms[0].creditBlickoins = parseFloat(data["creditBlickoins"]);
            });
        }
    break;
    case 'PACKAGES':
        // Si es package
        if (item.additionalInfo.roomsPackage) {
          this.serviceItinerary
            .getProfitability(item.additionalInfo.roomsPackage[0].netPrice, item.categoryId, item.providerId)
            .subscribe((data: any) => {
              item.additionalInfo.roomsPackage[0].netPriceProf = data.split("-")[0];
              item.additionalInfo.roomsPackage[0].percentage = data.split("-")[2];
            });
          item.additionalInfo.roomsPackage.forEach((room) => {
            this.serviceItinerary.getProfitability(room.optionNightsNetTotal, item.categoryId, item.providerId).subscribe((data: any) => {
              room.optionNightsNetTotalProf = data.split("-")[0];
              room.percentage = data.split("-")[2];
            });
          });
        }
        break;
        case 'TOUR':
        // Si es tour
        if (item.additionalInfo.tours) {
          item.additionalInfo.tours.options.forEach((option) => {
            this.serviceItinerary.getProfitability(option.prices.adult, item.categoryId, item.providerId).subscribe((data: any) => {
              option.prices.adultProf = data.split("-")[0];
              option.prices.adultFlag = data.split("-")[1];
            });
            this.serviceItinerary.getProfitability(option.prices.child, item.categoryId, item.providerId).subscribe((data: any) => {
              option.prices.childProf = data.split("-")[0];
              option.prices.childFlag = data.split("-")[1];
              option.prices.percentage = data.split("-")[2];
            });
            this.serviceItinerary.getProfitability(option.totalPrice, item.categoryId, item.providerId).subscribe((data: any) => {
              option.totalPriceProf = data.split("-")[0];
              option.totalPriceFlag = data.split("-")[1];
              option.percentage = data.split("-")[2];
              option.blickoins = parseFloat(data.split("-")[3]);
              option.creditBlickoins = data.split("-")[4];
            });
          });
        }
        break;
        case 'TRANSPORTS':
        // Si es transport
        if (item) {
          item.vehicles.forEach((vehicle: any) => {
            this.serviceItinerary
              .getProfitability(vehicle.pricing.totalPrice, 8, vehicle.providerId)
              .subscribe((data: any) => {
                vehicle.netPriceProf = parseFloat(data["totalPrice"]);
                // vehicle.totalPriceProf = parseFloat(data.split("-")[0]);
                // vehicle.totalPriceFlag = data.split("-")[1];
                vehicle.percentage =  parseFloat(data["percentage"]);
                // vehicle.vehicles[0].units = parseFloat(data.split("-")[2]);
                // vehicle.blickoins = parseFloat(data["blickoins"]);
                // vehicle.creditBlickoins = parseFloat(data["creditBlickoins"]);
              });


          })
          break;
        }

      // Otros casos de servicios
      //...
    }
  });
  this.arrayOut.emit(this.resultPaged);
}


  /**
   *
   * @description Reset valores de precios (slider)
   * @returns void
   */
  resetPriceSlider():void {
    if(this.results.length > 0){
      switch (String(this.payload?.categoriesId?.[0])) {
        case '1': //HOTELS
        this.priceResetLow;
        this.priceResetHigh;
          break;
        case '2': //RENTACAR
        this.filterHighPrice = this.results.map(function(el: any) {return el.additionalInfo.carRental.netPriceProf; }).reduce(function(prevEl: any, el: any) { return Math.min(prevEl, el); });
        this.filterLowPrice = this.results.map(function(el: any) {return el.additionalInfo.carRental.netPriceProf; }).reduce(function(prevEl: any, el: any) { return Math.max(prevEl, el); });
          break;
        case '6': //TOURS
        this.priceResetLow;
        this.priceResetHigh;
          break;
        case '8': //TRASLADO
        this.priceResetLow;
        this.priceResetHigh;
        break;

        default:
          this.filterHighPrice = 0;
          this.filterLowPrice = 0;
          break;
      }
    }

  }

  extractNameTransport(form: any, type: string, oneWay: boolean): string {

    if(!oneWay) {
      form = JSON.parse(localStorage.getItem('wayTransfer'));
      switch(type) {
        case 'origin':
          form = form[0]?.pickup;
          break;
        case 'destination':
          form = form[0]?.dropoff;
          break;
      }
    }

    switch(type) {
      case 'origin':
        switch(this.payload.transfers.pickupLocation.type) {
          case 'hotel':
            return form.name;
          case 'airport':
            return form.name;
          case 'destination':
            return form.city_name;
        }
      case 'destination':
        switch(this.payload.transfers.dropoffLocation.type) {
          case 'hotel':
            return form.name;
          case 'airport':
            return form.name;
          case 'destination':
            return form.city_name;
        }
    }
  }

  openModalForTransport(): void {
    this.openModalFly.emit();
  }

  validTotalPrice(): boolean {
    return Math.abs(this.filterHighPrice - this.filterLowPrice) > 1;
  }


getMessageFirstTime(pickupOrDropoff: any,input: string): string {

  let firstOrigin = {};
  let firstDestination = {};

  firstOrigin = input === 'origin' ? pickupOrDropoff : {};
  firstDestination = input === 'destination' ? pickupOrDropoff : {};

  let message: string = '';
  let messageFly: string = '';

  if(input === 'origin') {
    messageFly = pickupOrDropoff?.originDateTransfers === 'fly' ? 'Arribo del vuelo' : 'Hora del pickup';
  } else {
    messageFly = pickupOrDropoff?.originDateTransfers === 'fly' ? 'Arribo del vuelo' : 'Hora del pickup';
  }

  const messageDestination = 'Hora pickup del hotel';

  if(firstOrigin && firstOrigin['type']) {
    message = firstOrigin['type'] === 'airport' ? messageFly : messageDestination;
  }

  if(message === '') {
    message = firstDestination && firstDestination['type'] === 'airport' ? messageFly : messageDestination;
  }

  return message

  }

applyStarFilter(hoverIndex: number) {
  const color = this.headerStyle.card_line;
  const filterStr = this.generateColorFilter(color);

  this.buttons.forEach((button, i) => {
    const icon = button.nativeElement.querySelector('img');
    if (icon) {
      // Aplicar filtro si:
      // 1. Está bajo hover (hoverIndex >= i) O
      // 2. Está seleccionado (this.selectedStars >= i)
      const shouldColor = hoverIndex >= i || this.selectedStars >= i;
      icon.style.filter = shouldColor ? filterStr : 'none';
    }
  });
}

private generateColorFilter(hexColor: string): string {
  const tempFilterObj = CssFilterConverter.hexToFilter(hexColor, { sheen: false });
  const tempFilterStr = Object.keys(tempFilterObj)
    .map(key => `${key}(${tempFilterObj[key]})`)
    .join(' ');

  const colorMatch = tempFilterStr.match(/color\((.*)\)/);
  return colorMatch ? colorMatch[1] : '';
}


     applyImageFilter() {
      const color = this.headerStyle?.color_2;
      const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });

      //Extraemos el literal en String de la conversión
      const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");

      // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
      const colorRegex = /color\((.*)\)/;
      const colorMatch = tempFilterStr.match(colorRegex);
      const colorFilter = colorMatch ? colorMatch[1] : "";

      this.filterColorIcon = colorFilter;

      // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
      setTimeout(() => {
        this.icons?.forEach(icon => {
          icon.nativeElement.setAttribute('style', `filter: ${this.filterColorIcon}; width: 16px;`);
        });

         this.icons_two?.forEach(icon => {
          icon.nativeElement.setAttribute('style', `filter: ${this.filterColorIcon}; width: 14px;`);
        });
       // console.log(this.filter);
      }, 100);
    }

    getPayloadOneWay(): boolean {
        return this.payload?.transfers?.oneWay;
    }

    visualFilter(): boolean {
      const categoryId = this.payload?.categoriesId?.[0];
      if (categoryId === 10) {
        if(this.showFilters === true) {
            return true;
        } else {
          return false;
        }
      }

      return true;
    }


    qtyProductValidDecrement(): void {
      this.qtyProductValidDecrementEmmit.emit();
    }

        openFilter(): void {
      setTimeout(() => this.customizeSlider(), 100);
      this.showFilters = !this.showFilters;
    }

    getPaxesRooms(rooms: any, type: string): number {

      if(rooms) {
        let adults: number = 0;
        let childs: number = 0;

        rooms.roomConfiguration.forEach((room: any) => {
          adults += Number(room.adults);
          childs += room?.children?.length;
        });

        if(type === 'adults') {
          return adults;
        } else {
          return childs;
        }
      }

    }

    getCurrencyCategory(product: any): string {

      switch (String(this.payload?.categoriesId?.[0])) {
        case '1':
          return product[0]?.additionalInfo?.rooms[0]?.room.pricing?.currency;
        case '6':
          return product?.additionalInfo?.currency;
        case '8':
          return product?.vehicles[0]?.pricing?.currency;
        case '5':
          return product?.price?.currency;
      }

      return 'USD';
    }

    reloadEditPencilSearch(): void {
      this.reloadEditPencilEmitter.emit();
    }

    mapMarker(event: boolean): void {
      this.viewMapsResult = event;
      this.emitViewMap.emit(event);

        if(!event) {
            setTimeout(() => {
              this.customizeSlider();
            }, 0);

        }
    }

  getDays(dateIn: any, dateOut: any): any {
    // Convertir a milisegundos y calcular diferencia
    const diffInMs = new Date(dateOut).getTime() - new Date(dateIn).getTime();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    let daysText: string = '';

    daysText = diffInDays === 1 ?
                `${diffInDays.toString()} día` :
                `${diffInDays.toString()} días`;

    return daysText;

  }

  getNights(dateIn: any, dateOut: any): any {
    // Convertir a milisegundos y calcular diferencia
    const diffInMs = new Date(dateOut).getTime() - new Date(dateIn).getTime();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    let daysText: string = '';

    daysText = diffInDays === 1 ?
                `${diffInDays.toString()} noche` :
                `${diffInDays.toString()} noches`;

    return daysText;

  }

    getPrimerProducto(): any {
    const productos = this.containerResults.toArray();
    return productos.length > 0 ? productos[0] : null;
  }

    ejecutarEnPrimerProducto(metodo: string, ...args: any[]) {
    const primerProducto = this.getPrimerProducto();
    if (primerProducto && primerProducto[metodo]) {
      primerProducto[metodo](...args);
    }
  }

getFiltersApply(): string {
  const categoryId = this.payload?.categoriesId?.[0];
  const activeFilters: string[] = [];

  // Orden de precio (común a todos)
  if (this.orderPriceby === "priceLow") activeFilters.push('Menor precio');
  if (this.orderPriceby === "priceHigh") activeFilters.push('Mayor precio');



  // Rango de precio
  if (this.isPriceRangeFilterActive() && ![2, 6].includes(categoryId)) {
    activeFilters.push('Rango de precio');
  }

  // Filtros específicos de categoría
  const categoryFilters = this.filterConfig[categoryId] || [];
  for (const filter of categoryFilters) {
    if (filter.isActive()) activeFilters.push(filter.name);
  }

  return activeFilters.join(', ');
}

// Método para obtener los filtros como array de objetos (para los chips)
getFiltersChips(): FilterChip[] {
  const categoryId = this.payload?.categoriesId?.[0];
  const chips: FilterChip[] = [];

  // Orden de precio
  if (this.orderPriceby === "priceLow") {
    chips.push({ name: 'Menor precio', type: 'order', value: 'priceLow' });
  }
  if (this.orderPriceby === "priceHigh") {
    chips.push({ name: 'Mayor precio', type: 'order', value: 'priceHigh' });
  }

  // Rango de precio
  if (this.isPriceRangeFilterActive() && ![2, 6].includes(categoryId)) {
    chips.push({ name: 'Rango de precio', type: 'priceRange' });
  }

  // Filtros por categoría - CON VALORES ESPECÍFICOS
  switch (categoryId) {
    case 1: // Hoteles
      if (this.text?.trim()) {
        chips.push({ name: `${this.text}`, type: 'text', value: this.text });
      }
      if (this.selectedStars > 0) {
        chips.push({ name: `${this.selectedStars} estrella${this.selectedStars > 1 ? 's' : ''}`, type: 'stars', value: this.selectedStars });
      }
      // ✅ Cada régimen seleccionado como chip individual
      const board: any = this.selectedBoardKeys.forEach(boardKey => {

        let boardSelected: any;

        this.mealsFilter?.find(b =>{
         boardSelected = b.matches.find(match => match.toLowerCase() === boardKey.toLowerCase())
        });

          return boardSelected;
      });

       if(board) {
          const boardLabel = board?.label;
          chips.push({ name: `${boardLabel}`, type: 'board', value: board });
        }

      // ✅ Cada tipo de cancelación seleccionado como chip individual
      this.selectedRateTypes.forEach(rateType => {
        const rateLabel = rateType === 'R' ? 'Reembolsable' : 'No reembolsable';
        chips.push({ name: `${rateLabel}`, type: 'cancellation', value: rateType });
      });
      // ✅ Cada amenity seleccionado como chip individual
      this.selectedAmenityKeywords.forEach(amenityKey => {
        const amenityLabel = this.amenitiesFilter?.find(a => a.key === amenityKey)?.label || amenityKey;
        chips.push({ name: `${amenityLabel}`, type: 'amenities', value: amenityKey });
      });
      break;

    case 2: // Rent a Car
      this.acrissSelected?.forEach(vehicleKey => {
        const vehicleLabel = this.acrissFilter?.find(v => v.key === vehicleKey)?.label || vehicleKey;
        chips.push({ name: `${vehicleLabel}`, type: 'vehicle', value: vehicleKey });
      });
      this.maxPaxSelected?.forEach(paxKey => {
        chips.push({ name: `${paxKey}`, type: 'passengers', value: paxKey });
      });
      this.luggageSelected?.forEach(doorsKey => {
        chips.push({ name: `${doorsKey}`, type: 'doors', value: doorsKey });
      });
      this.supplierRentACarSelected?.forEach(supplierKey => {
        const supplierLabel = this.supplierContractRentACarFilter?.find(s => s.key === supplierKey)?.label || supplierKey;
        chips.push({ name: `${supplierLabel}`, type: 'rentadora', value: supplierKey });
      });
      break;

    case 6: // Tours
      if (this.text?.trim()) {
        chips.push({ name: `${this.text}`, type: 'text', value: this.text });
      }
      this.filter.forEach(f => {
        if (f.path === 'language') {
          const languageLabel = this.languageFilter?.find(l => l.key === f.values[0])?.label || f.values[0];
          chips.push({ name: `${languageLabel}`, type: 'language', value: f.values[0] });
        }
        if (f.path === 'sessions') {
          const sessionLabel = this.sessionsFilter?.find(s => s.key === f.values[0])?.label || f.values[0];
          chips.push({ name: `H${sessionLabel}`, type: 'schedule', value: f.values[0] });
        }
      });
      break;

    case 8: // Transportes
      this.filter.forEach(f => {
        if (f.path === 'vehicle.type') {

          chips.push({ name: `${f.values[0]}`, type: 'vehicleType', value: f.values[0] });
        }
        if (f.path === 'transferType') {
          chips.push({ name: `${f.values[0]}`, type: 'service', value: f.values[0] });
        }
      });
      break;

    case 5: // Vuelos
      this.selectedStopsFlights.forEach(key => {
        const label = this.stopsFilterFlights?.find(s => s.key === key)?.label || key;
        chips.push({ name: label, type: 'stops', value: key });
      });
      this.selectedAirlinesFlights.forEach(key => {
        const label = this.airlinesFilterFlights?.find(a => a.key === key)?.label || key;
        chips.push({ name: label, type: 'airline', value: key });
      });
      this.selectedCabinClassesFlights.forEach(key => {
        const label = this.cabinClassFilterFlights?.find(c => c.key === key)?.label || key;
        chips.push({ name: label, type: 'cabinClass', value: key });
      });
      this.selectedDepartureAirportsFlights.forEach(key => {
        const label = this.departureAirportsFilterFlights?.find(a => a.key === key)?.label || key;
        chips.push({ name: label, type: 'departureAirport', value: key });
      });
      this.selectedDepartureTimeFlights.forEach(key => {
        const label = this.departureTimeFilterFlights?.find(t => t.key === key)?.label || key;
        chips.push({ name: `Salida: ${label}`, type: 'departureTime', value: key });
      });
      this.selectedArrivalTimeFlights.forEach(key => {
        const label = this.arrivalTimeFilterFlights?.find(t => t.key === key)?.label || key;
        chips.push({ name: `Llegada: ${label}`, type: 'arrivalTime', value: key });
      });
      this.selectedFlightAttributes.forEach(key => {
        const label = this.flightAttributesFilter?.find(a => a.key === key)?.label || key;
        chips.push({ name: label, type: 'flightAttribute', value: key });
      });
      if (this.selectedMaxDurationHoursFlights !== null && this.selectedMaxDurationHoursFlights < this.flightDurationRangeHours.max) {
        chips.push({ name: `Menos de ${this.selectedMaxDurationHoursFlights} hs`, type: 'duration', value: this.selectedMaxDurationHoursFlights });
      }
      break;
  }

  return chips;
}

removeFilter(chip: FilterChip): void {
  console.log(chip)
  switch (chip.type) {
    case 'order':
      this.orderPriceby = '';
      break;

    case 'priceRange':
      this.resetPriceSlider();
      break;

    case 'text':
      this.text = '';
      break;

    case 'stars':
      this.selectedStars = 0;
      this.resetStarsVisual();
      break;

    case 'board':
      // ✅ Eliminar solo el board específico
      const boardIndex = this.selectedBoardKeys.indexOf(chip.value);
      if (boardIndex !== -1) {
        this.selectedBoardKeys.splice(boardIndex, 1);
      }
      // Desmarcar solo ese checkbox
      this.uncheckSpecificBoardFilter(chip.value);
      break;

    case 'cancellation':
      // ✅ Eliminar solo el rate type específico
      const rateIndex = this.selectedRateTypes.indexOf(chip.value);
      if (rateIndex !== -1) {
        this.selectedRateTypes.splice(rateIndex, 1);
      }
      this.uncheckSpecificCancellationFilter(chip.value);
      break;

    case 'amenities':
      // ✅ Eliminar solo el amenity específico
      const amenityIndex = this.selectedAmenityKeywords.indexOf(chip.value);
      if (amenityIndex !== -1) {
        this.selectedAmenityKeywords.splice(amenityIndex, 1);
      }
      this.uncheckSpecificAmenityFilter(chip.value);
      break;

    case 'vehicle':
      const vehicleIndex = this.acrissSelected.indexOf(chip.value);
      if (vehicleIndex !== -1) {
        this.acrissSelected.splice(vehicleIndex, 1);
      }
      this.uncheckSpecificVehicleFilter(chip.value);
      break;

    case 'passengers':
      const passengerIndex = this.maxPaxSelected.indexOf(Number(chip.value));
      if (passengerIndex !== -1) {
        this.maxPaxSelected.splice(passengerIndex, 1);
      }
      this.uncheckSpecificPassengerFilter(chip.value);
      break;

    case 'doors':
      const doorsIndex = this.luggageSelected.indexOf(Number(chip.value));
      if (doorsIndex !== -1) {
        this.luggageSelected.splice(doorsIndex, 1);
      }
      this.uncheckSpecificDoorsFilter(chip.value);
      break;

    case 'rentadora':
      const supplierIndex = this.supplierRentACarSelected.indexOf(chip.value);
      if (supplierIndex !== -1) {
        this.supplierRentACarSelected.splice(supplierIndex, 1);
      }
      this.uncheckSpecificSupplierFilter(chip.value);
      break;

    case 'language':
      // Eliminar del array filter
      this.filter = this.filter.filter(f => !(f.path === 'language' && f.values[0] === chip.value));
      this.languageKeys = this.languageKeys.filter(k => k !== chip.value);
      this.uncheckSpecificLanguageFilter(chip.value);
      break;

    case 'schedule':
      this.filter = this.filter.filter(f => !(f.path === 'sessions' && f.values[0] === chip.value));
      this.sessionsKeys = this.sessionsKeys.filter(k => k !== chip.value);
      this.uncheckSpecificScheduleFilter(chip.value);
      break;

    case 'vehicleType':
      this.filter = this.filter.filter(f => !(f.path === 'vehicleType' && f.values[0] === chip.value));
      this.uncheckSpecificVehicleTypeFilter(chip.value);
      break;

    case 'service':
      this.filter = this.filter.filter(f => !(f.path === 'transferType' && f.values[0] === chip.value));
      this.uncheckSpecificServiceFilter(chip.value);
      break;
  }

  this.applyAllFilters();
}

// ==================== MÉTODOS PARA DESMARCAR UN CHECKBOX ESPECÍFICO ====================

private uncheckSpecificBoardFilter(boardKey: string): void {
  const checkbox = document.querySelector(`.board-checkbox[value="${boardKey}"]`) as HTMLInputElement;
  if (checkbox) checkbox.checked = false;
}

private uncheckSpecificCancellationFilter(rateType: string): void {
  const checkbox = document.querySelector(`.cancellation-checkbox[value="${rateType}"]`) as HTMLInputElement;
  if (checkbox) checkbox.checked = false;
}

private uncheckSpecificAmenityFilter(amenityKey: string): void {
  const checkbox = document.querySelector(`.amenity-checkbox[value="${amenityKey}"]`) as HTMLInputElement;
  if (checkbox) checkbox.checked = false;
}

private uncheckSpecificVehicleFilter(vehicleKey: string): void {
  const checkbox = document.querySelector(`.vehicle-checkbox[value="${vehicleKey}"]`) as HTMLInputElement;
  if (checkbox) checkbox.checked = false;
}

private uncheckSpecificPassengerFilter(passengerKey: string): void {
  const checkbox = document.querySelector(`.passenger-checkbox[value="${passengerKey}"]`) as HTMLInputElement;
  if (checkbox) checkbox.checked = false;
}

private uncheckSpecificDoorsFilter(doorsKey: string): void {
  const checkbox = document.querySelector(`.doors-checkbox[value="${doorsKey}"]`) as HTMLInputElement;
  if (checkbox) checkbox.checked = false;
}

private uncheckSpecificSupplierFilter(supplierKey: string): void {
  const checkbox = document.querySelector(`.supplier-checkbox[value="${supplierKey}"]`) as HTMLInputElement;
  if (checkbox) checkbox.checked = false;
}

private uncheckSpecificLanguageFilter(languageKey: string): void {

   const checkbox = document.querySelector(`.language-checkbox[value="${languageKey}"]`) as HTMLInputElement;

  if (checkbox) {
    checkbox.checked = false;
  } else {
    console.log(languageKey)
    console.log(this.languageFilter[0].matches[0])
    const languageLabel = this.languageFilter?.find(s => s.matches[0] === languageKey)?.label;

    if (languageLabel) {
      const fallbackCheckbox = document.querySelector(`.language-checkbox[value="${languageKey}"]`) as HTMLInputElement;
      if (fallbackCheckbox) {
        fallbackCheckbox.checked = false;
      }
    }
  }
}

private uncheckSpecificScheduleFilter(scheduleKey: string): void {
  const checkbox = document.querySelector(`.schedule-checkbox[value="${scheduleKey}"]`) as HTMLInputElement;
  if (checkbox) checkbox.checked = false;
}

private uncheckSpecificVehicleTypeFilter(serviceKey: string): void {

    const checkbox = document.querySelector(`.vehicle-checkbox[value="${serviceKey}"]`) as HTMLInputElement;

  if (checkbox) {
    checkbox.checked = false;
  } else {
    const serviceLabel = this.vehicleTypeFilter?.find(s => s.matches[0] === serviceKey)?.label;
    if (serviceLabel) {
      const fallbackCheckbox = document.querySelector(`.vehicle-checkbox[value="${serviceLabel}"]`) as HTMLInputElement;
      if (fallbackCheckbox) {
        fallbackCheckbox.checked = false;
      }
    }
  }

}

private uncheckSpecificServiceFilter(serviceKey: string): void {

  // Buscar por la clave (key) del servicio
  const checkbox = document.querySelector(`.service-checkbox[value="${serviceKey}"]`) as HTMLInputElement;

  if (checkbox) {
    checkbox.checked = false;
  } else {
    // Fallback: buscar por el label (si es necesario)
    const serviceLabel = this.vehicleServiceFilter?.find(s => s.matches[0] === serviceKey)?.label;
    if (serviceLabel) {
      const fallbackCheckbox = document.querySelector(`.service-checkbox[value="${serviceLabel}"]`) as HTMLInputElement;
      if (fallbackCheckbox) {
        fallbackCheckbox.checked = false;
      }
    }
  }
}

private resetStarsVisual(): void {
  this.selectedStars = 0;
  this.applyStarFilter(-1);
}

private isPriceRangeFilterActive(): boolean {
  // Verifica si el slider se ha movido de su posición inicial
  const minPrice = this.getMinPrice();
  const maxPrice = this.getMaxPrice();

  if (minPrice === null || maxPrice === null) return false;

  // Considera una pequeña tolerancia para errores de redondeo
  const tolerance = 0.01;
  return this.filterLowPrice > minPrice + tolerance ||
         this.filterHighPrice < maxPrice - tolerance;
}


// Obtener el precio mínimo real de los productos
getMinPrice(): number | null {
  if (!this.resultsAux || this.resultsAux.length === 0) return null;

  const prices = this.resultsAux.map(item => {
    switch(this.payload?.categoriesId?.[0]) {
      case 1:
        return item.additionalInfo?.rooms[0]?.room?.optionNightsNetTotalProf || 0;
      case 2:
        return item.additionalInfo?.carRental?.totalPriceProf || 0;
      case 5:
        return getFlightPrice(item);
      case 6:
        return item.additionalInfo?.tours?.options[0]?.profility[0]?.netPriceBooking || 0;
      case 8:
        return item.vehicles?.[0]?.totalPriceProf || 0;
      default:
        return 0;
    }
  }).filter(p => p > 0); // ← Filtrar precios > 0

  if (prices.length === 0) return null;
  return Math.min(...prices);
}

getMaxPrice(): number | null {
  if (!this.resultsAux || this.resultsAux.length === 0) return null;

  const prices = this.resultsAux.map(item => {
    switch(this.payload?.categoriesId?.[0]) {
      case 1:
        return item.additionalInfo?.rooms[0]?.room?.optionNightsNetTotalProf || 0;
      case 2:
        return item.additionalInfo?.carRental?.totalPriceProf || 0;
      case 5:
        return getFlightPrice(item);
      case 6:
        return item.additionalInfo?.tours?.options[0]?.profility[0]?.netPriceBooking || 0;
      case 8:
        return item.vehicles?.[0]?.totalPriceProf || 0;
      default:
        return 0;
    }
  }).filter(p => p > 0);

  if (prices.length === 0) return null;
  return Math.max(...prices);
}



}
